import React, { useEffect, useRef, useState } from "react"
import { Link, useLocation, useNavigate, useParams } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  Card,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Label,
  Row,
  UncontrolledAccordion,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Accordion,
} from "reactstrap"
import {
  Controller,
  FormProvider,
  useFieldArray,
  useForm,
} from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import {
  UFDate,
  UFEditor,
  UFInput,
  UFInputNumber,
} from "../../../components/Common/Fields/Input"
import CurrencyList from "../../../components/Common/chooseFields/currency"
import Country from "../../../components/Common/chooseFields/country"
import PaymentMode from "../../../components/Common/chooseFields/paymentMode"
import LoadingButton from "../../../components/Common/LoadingButton"
import {
  fetchSupplier,
  postSupplier,
} from "../../../services/procurement/supplier"
import uploadicon from "../../../assets/icons/export-light.svg"
import GradeChoose from "../../../components/Common/chooseFields/grade"
import {
  benefitsList,
  entitlementList,
  fetchFinanceLedgersLi,
} from "../../../services/Settings/dropdown"
import Select from "react-select"
import DynamicDropdown from "../../../components/Common/chooseFields/dynamicDropdown"
import {
  fetchHrmsGradeControlEdit,
  postHrmsGradeControl,
} from "../../../services/Hrms/hrms"
import { capitalize } from "lodash"
import FinanceGroupType from "../../../components/Common/chooseFields/financeGroupType"
import BankList from "../../../components/Common/chooseFields/bankList"
import ConfigLi from "../../../components/Common/chooseFields/config"
import {
  fetchFinanceLedgerSingle,
  postFinanceLedger,
} from "../../../services/finance/finance"
import BalanceTypeDrop from "../../../components/Common/chooseFields/balanceType"
import VatCalculationMethod from "../../../components/Common/chooseFields/vatCalculation"
import CreditPeriod from "../../../components/Common/chooseFields/creditPeriod"
import EditFinanceGroup from "../groups/edit"
import EditFinanceGroupField from "../groupFields/edit"
import NatureOfTransactions from "../../../components/Common/chooseFields/natureOfTransactions"
import FinanceLedgersLi from "../../../components/Common/chooseFields/ledgers"
import SubledgersMultiLi from "../../../components/Common/chooseFields/subledgersMultiLi"
import ParentSubledgerLi from "../../../components/Common/chooseFields/parentSubledgerLi"
import VatTypesLi from "../../../components/Common/chooseFields/vatTypesLi"
import VatTypesLists from "../../../components/Common/chooseFields/vatTypesLists"
import moment from "moment"
import DutyTypes from "../../../components/Common/chooseFields/dutyType"
import PhoneInputField from "../../../components/Common/Fields/phoneInput"
import CustomerType from "../../../components/Common/chooseFields/customerType"
import TrashIcon from "../../../assets/icons/iconComponents/trashIcon"
import { getCode } from "../../../services/inventory"
import CalcualtionTypeInterest from "../../../components/Common/chooseFields/calcualtionTypeInterest"
import StateList from "../../../components/Common/chooseFields/stateList"
import UploadArrowIcon from "../../../assets/icons/iconComponents/uploadArrowIcon"
import ReferenceType from "../../../components/Common/chooseFields/refType"
import closeIcon from "../../../assets/icons/close.svg"
import DebitCreditDrop from "../../../components/Common/chooseFields/debitCredit"
import StateOnlyList from "../../../components/Common/chooseFields/stateonlyLi"
import CreditPaymentMethod from "../../../components/Common/chooseFields/creditPayment"

const schema = yup.object().shape({
  name: yup.string().required("Ledger Name is Required"),
  account_group_id: yup.mixed().when("is_subledger_entry", {
    is: true,
    then: schema => schema.notRequired().nullable(),
    otherwise: schema => schema.required("Under Group is Required"),
  }),
  is_interest_calculation: yup.boolean().default(false),
  // cc_credit_period: yup.mixed().when("is_interest_calculation", {
  //   is: true,
  //   then: schema =>
  //     schema
  //       .required("Credit Period is Required")
  //       .test(
  //         "is-valid-credit-period",
  //         "Credit Period must be a valid selection",
  //         value =>
  //           value &&
  //           (typeof value === "number" ||
  //             (typeof value === "object" && "value" in value))
  //       ),
  //   otherwise: schema => schema.notRequired(),
  // }),
  // calculation_type: yup.mixed().when("is_interest_calculation", {
  //   is: true,
  //   then: schema =>
  //     schema
  //       .required("Calculation Type is Required")
  //       .test(
  //         "is-valid-credit-period",
  //         "Calculation Type must be a valid selection",
  //         value =>
  //           value &&
  //           (typeof value === "number" ||
  //             (typeof value === "object" && "value" in value))
  //       ),
  //   otherwise: schema => schema.notRequired(),
  // }),
  // Calculation Percentage is validated only when Interest Calculation is genuinely ON.
  // The checkbox is state-controlled (not registered), so the sibling `is_interest_calculation`
  // value yup reads can drift truthy after switching nature/unticking — which used to make this
  // required for a hidden field and silently block Save. Gate on the checkbox's own value AND a
  // non-empty percentage so it never blocks when interest is off or the field isn't shown.
  cal_per: yup
    .number()
    .nullable()
    .transform(value => (isNaN(value) ? undefined : value))
    .when("is_interest_calculation", {
      is: v => v === true || v === 1 || v === "1",
      then: schema =>
        schema.min(0, "Calculation Percentage must be a positive number"),
      otherwise: schema => schema.notRequired(),
    }),
  trn: yup
    .string()
    .notRequired()
    .nullable()
    .test(
      "is-15-digits",
      "TRN must be exactly 15 digits",
      value => !value || /^\d{15}$/.test(value)
    ),
  vat_per: yup
    .number()
    .nullable()
    .transform(value => (isNaN(value) ? undefined : value))
    .when("account_group_id", {
      is: val => val?.value == 17,
      then: schema =>
        schema
          .required("VAT % is required")
          .typeError("VAT % must be a number"),
      otherwise: schema => schema.notRequired(),
    }),

  customer_type: yup.mixed().when("account_group_id", {
    is: val => val?.value == 13,
    then: schema => schema.required("Customer Type is Required"),
    otherwise: schema => schema.notRequired(),
  }),

  opening_balance: yup
    .number()
    .nullable()
    .typeError("Opening Balance must be a number")
    .min(0, "Opening Balance must be a positive number")
    .transform(value => (isNaN(value) ? undefined : value))
    .test(
      "log-opening-balance",
      "Opening Balance is invalid",
      function (value) {
        console.log("Opening Balance:", value)
        return true // Always return true, since this test is only for logging
      }
    ),
  voucher_contra_partial_pay: yup
    .array()
    .of(
      yup.object().shape({
        code: yup.string().trim().required("Reference Number is Required"),
        amount: yup
          .number()
          .typeError("Amount must be a number")
          .min(0, "Amount must be a positive number")
          .transform(value => (isNaN(value) ? undefined : value)),
        date: yup
          .date()
          .typeError("Date must be a valid date")
          .required("Date is Required"),
        due_date: yup
          .date()
          .typeError("Due Date must be a valid date")
          .required("Due Date is Required"),
      })
    )
    .when(["opening_balance", "account_group_id"], {
      is: (opening_balance, account_group_id) =>
        opening_balance > 0 && [13, 22, 30, 31].includes(account_group_id),
      then: schema => schema.min(1, "At least one partial payment is required"),
      otherwise: schema => schema.notRequired(),
    }),
  balance_type: yup.mixed().when(["opening_balance", "account_group_id"], {
    is: (opening_balance, account_group_id) =>
      opening_balance > 0 &&
      (account_group_id?.value === 13 || account_group_id?.value === 22),
    then: schema =>
      schema
        .required("Balance Type is Required")
        .test(
          "is-valid-balance-type",
          "Balance Type must be a valid selection",
          value =>
            value &&
            (typeof value === "string" ||
              (typeof value === "object" && "value" in value))
        ),
    otherwise: schema => schema.notRequired(),
  }),
  // bill_no: yup.string().when(["opening_balance", "account_group_id"], {
  //   is: (opening_balance, account_group_id) =>
  //     opening_balance > 0 &&
  //     (account_group_id?.value === 13 || account_group_id?.value === 22),
  //   then: schema =>
  //     schema
  //       .required("Bill Number is Required")
  //       .min(1, "Bill Number cannot be empty"),
  //   otherwise: schema => schema.notRequired(),
  // }),
  // bill_type_id: yup.mixed().when(["opening_balance", "account_group_id"], {
  //   is: (opening_balance, account_group_id) =>
  //     opening_balance > 0 &&
  //     (account_group_id?.value === 13 || account_group_id?.value === 22),
  //   then: schema =>
  //     schema
  //       .required("Bill Type is Required")
  //       .test(
  //         "is-valid-bill-type",
  //         "Bill Type must be a valid selection",
  //         value =>
  //           value &&
  //           (typeof value === "number" ||
  //             (typeof value === "object" && "value" in value))
  //       ),
  //   otherwise: schema => schema.notRequired(),
  // }),
  // bill_date: yup.date().when(["opening_balance", "account_group_id"], {
  //   is: (opening_balance, account_group_id) =>
  //     opening_balance > 0 &&
  //     (account_group_id?.value === 13 || account_group_id?.value === 22),
  //   then: schema =>
  //     schema
  //       .required("Bill Date is Required")
  //       .typeError("Bill Date must be a valid date")
  //       .max(new Date(), "Bill Date cannot be in the future"),
  //   otherwise: schema => schema.notRequired(),
  // }),
  // closing_date: yup.date().when("opening_balance", {
  //   is: opening_balance => opening_balance > 0,
  //   then: schema =>
  //     schema
  //       .required("Closing Date is Required")
  //       .typeError("Closing Date must be a valid date"),
  //   otherwise: schema => schema.notRequired(),
  // }),

  // serviece_type: yup.mixed().when("account_group_id.type.id", {
  //   is: id => id === 3 || id === 4,
  //   then: schema => schema.required("Service Type is Required"),
  //   otherwise: schema => schema.notRequired(),
  // }),

  // nature_of_transaction: yup.mixed().when("account_group_id.type.id", {
  //   is: id => id === 3 || id === 4,
  //   then: schema => schema.required("Nature of Transaction is Required"),
  //   otherwise: schema => schema.notRequired(),
  // }),

  // vat_type: yup.mixed().when("account_group_id", {
  //   is: group =>
  //     group?.id === 13 ||
  //     group?.id === 22 ||
  //     group?.parent?.id === 13 ||
  //     group?.parent?.id === 22 ||
  //     group?.parent?.parent_id === 13 ||
  //     group?.parent?.parent_id === 22,
  //   then: schema => schema.required("VAT Type is Required"),
  //   otherwise: schema => schema.notRequired(),
  // }),
})

const fieldToAccordionMap = {
  name: "0", // Outside accordion, but you can handle it if needed
  account_group_id: "0", // Outside accordion
  customer_code: "0",
  suppliers_code: "0",
  creditperiod: "0",
  vat_type: "1",
  vat_registration_date: "1",
  trn: "1",
  duty_type: "1",
  vat_per: "1",
  vat_cal: "1",
  serviece_type: "1",
  nature_of_transaction: "1",
  ban_account_name: "2",
  ban_account_num: "2",
  ban_bank_name: "2",
  branch_name: "2",
  ban_iban: "2",
  swift_code: "2",
  ban_after_range_check_book: "3",
  ban_check_printing: "3",
  ban_after_check_printing: "3",
  customer_type: "4",
  email_id: "4",
  address: "4",
  contact_person: "4",
  customer_number: "4",
  contact_person_designation: "4",
  contact_person_two: "4",
  customer_number_two: "4",
  contact_person_designation_two: "4",
  country_id_1: "4",
  country_id: "4",
  currency_id: "4",
  trade_licence_no: "4",
  trade_document_expiry_date: "4",
  po_box_no: "4",
  vat_no: "4",
  vat_document_expiry_date: "4",
  // is_subcontractor: "4",
  mail_name: "4",
  mail_add: "4",
  mail_emirate: "4",
  mail_country: "4",
  opening_balance: "9",
  balance_type: "9",
  bill_no: "9",
  // bill_type_id: "9",
  // bill_date: "9",
  // closing_date: "9",
  // is_interest_calculation: "8",
  cc_credit_period: "8",
  calculation_type: "8",
  cal_per: "8",
}

const LedgerForm = ({
  // Props for controlling offcanvas behavior
  isOffcanvas = false,
  isOpen = false,
  toggleOffcanvas = () => {},
  offcanvasHeader = "Ledger Form",
  // Props for form behavior
  formId = "ledger-form",
  onSuccess = () => {},
  onError = () => {},
  // Other props
  ledgerId = null,
  defaultValues = {
    // voucher_contra_partial_pay: [
    //   {
    //     nature: { label: "Cr", value: "credit" },
    //     account_id: null,
    //     amount: 0,
    //     date: moment("DD-MM-MMMM"),
    //     voucher_id: null,
    //   },
    // ],
  },
  defaultGroupId,
}) => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Ledger${companyname ? ` | ${companyname}` : "MEP -Hub"}`
  const navigate = useNavigate()
  const { id } = useParams()
  const resolvedLedgerId = ledgerId || id

  const drCrRefs = useRef([])

  const desimalrange = localStorage.getItem("desimalrange")

  const locations = useLocation()
  const crumb = locations?.state?.menuLabel || ""
  // const group = locations?.state?.group || ""
  // const search = locations?.state?.search || ""

  const [isLoading, setIsLoading] = useState(false)
  const [isModal, setModal] = useState(false)
  const [bankCheck, setBankCheck] = useState(false)
  const [billWise, setBillWise] = useState(false)
  // const [openingBalance, setOpeningBalance] = useState(false)
  const [vatApplicable, setVatApplicable] = useState(false)
  // const [costCenter, setCostCenter] = useState(false)
  const [interestCalculation, setInterestCalculation] = useState(false)
  const [subLedger, setSubLedger] = useState(false)
  // "is SubLedger" = this ledger IS a subledger (minimal save, no features). Adding from the
  // listing's Subledgers tab arms it up front; an edit always takes the flag from the record.
  const [isSubledgerEntry, setIsSubledgerEntry] = useState(
    !resolvedLedgerId && !!locations?.state?.isSubledger
  )

  const [showAdditionalContacts, setShowAdditionalContacts] = useState(false)

  const [vatFile, setVatFile] = useState()
  const [vendorFile, setVendorFile] = useState()
  const [tradeFile, setTradeFile] = useState()

  const [isChecked, setIsChecked] = useState()

  const [openAccordions, setOpenAccordions] = useState(["8"])
  const [veRemove, setVERemove] = useState([])

  const now = moment()

  const {
    control,
    handleSubmit,
    reset,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {},
    mode: "onChange",
    shouldFocusError: true,
  })

  // Keep a form-tracked flag in sync with the "is SubLedger" checkbox so the schema can make
  // Nature of Account optional for subledgers (they belong to the subledger group instead).
  useEffect(() => {
    setValue("is_subledger_entry", isSubledgerEntry, { shouldValidate: true })
  }, [isSubledgerEntry, setValue])

  // Watch for errors and update open accordions
  useEffect(() => {
    const errorFields = Object.keys(errors)
    const accordionsToOpen = new Set(openAccordions)

    errorFields.forEach(field => {
      const accordionId = fieldToAccordionMap[field]
      if (accordionId && !accordionsToOpen.has(accordionId)) {
        accordionsToOpen.add(accordionId)
      }
    })

    // Handle nested errors (e.g., voucher_contra_partial_pay)
    if (errors.voucher_contra_partial_pay) {
      setModal(true) // Open the Opening Balance accordion
    }

    console.log("Errors:", errors, "Open Accordions:", [...accordionsToOpen])

    setOpenAccordions([...accordionsToOpen])
  }, [errors])

  // ... inside LedgerForm
  const toggleAccordion = id => {
    setOpenAccordions(prev =>
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
    )
  }

  useEffect(() => {
    const handleEdit = async id => {
      const response = await fetchFinanceLedgerSingle(id)
      if (id) {
        setBillWise(response?.data?.is_bill_wise != 0 ? true : false)
        setVatApplicable(response?.data?.is_vat_applicable != 0 ? true : false)
        setInterestCalculation(
          response?.data?.is_interest_calculation != 0 ? true : false
        )
        setSubLedger(response?.data?.is_sub_ledger != 0 ? true : false)
        setIsSubledgerEntry(response?.data?.is_subledger != 0 ? true : false)
        setIsChecked(
          response?.data?.supplier?.is_subcontractor === 1 ? true : false
        )
        setTradeFile(
          response?.data?.supplier?.trade?.[0]?.file_path?.split("/").pop()
        )
        setVatFile(
          response?.data?.supplier?.vat?.[0]?.file_path?.split("/").pop()
        )
        setVendorFile(response?.data?.supplier?.vendor_document)

        const voucherEntryArr = response?.data?.journal_entries_details
          ?.filter(dt => dt?.journal_entries?.voucher_entry?.voucher_id == 20)
          ?.map(dt => ({
            table_id: dt?.id,
            voucher_id: 20,
            code: dt?.journal_entries?.reference_number,
            due_date: dt?.journal_entries?.voucher_entry?.due_date,
            date: dt?.journal_entries?.voucher_entry?.date,
            amount: dt?.credit_amount ? dt?.credit_amount : dt?.debit_amount,
            type: dt?.credit_amount
              ? { label: "Cr", value: "credit" }
              : { label: "Dr", value: "debit" },
            voucherType: "Opening Balance",
            voucher_entry_id: dt?.journal_entries?.voucher_entry_id,
          }))
        reset({
          ...response?.data,
          // The multi-select needs {value,label}; response.data.subledger_ids is a raw id array,
          // so map from response.data.subledgers (overrides the spread above).
          subledger_ids: Array.isArray(response?.data?.subledgers)
            ? response.data.subledgers.map(s => ({ value: s.id, label: s.name }))
            : [],
          // the select needs {value,label}; the response carries the raw id + name
          parent_subledger_id: response?.data?.parent_subledger_id
            ? {
                value: response.data.parent_subledger_id,
                label: response.data.parent_subledger_name,
              }
            : null,
          voucher_contra_partial_pay: voucherEntryArr,
          customer_code: response?.data?.customer?.customer_code,
          customer_type: response?.data?.customer?.customer_type,
          email_id: response?.data?.customer?.email_id,
          contact_person: response?.data?.customer?.contact_person,
          customer_number: response?.data?.customer?.customer_number,
          contact_person_designation:
            response?.data?.customer?.contact_person_designation,
          contact_person_two: response?.data?.customer?.contact_person_two,
          customer_number_two: response?.data?.customer?.customer_number_two,
          branch_name: response?.data?.ban_branch_name
            ? response?.data?.ban_branch_name
            : "",
          trn: response?.data?.vat_no ? response?.data?.vat_no : "",
          vat_type: response?.data?.vat_type?.id
            ? {
                label: response?.data?.vat_type?.label,
                value: response?.data?.vat_type?.id,
              }
            : null,
          serviece_type: response?.data?.serviece_type?.id
            ? {
                label: response?.data?.serviece_type?.label,
                value: response?.data?.serviece_type?.id,
              }
            : null,
          account_group_id: {
            label: response?.data?.account_group?.name,
            value: response?.data?.account_group?.id,
            ...response?.data?.account_group,
          },
          nature_of_transaction: response?.data?.nature_of_transaction?.id
            ? {
                label: response?.data?.nature_of_transaction?.label,
                value: response?.data?.nature_of_transaction?.id,
              }
            : null,
          ban_after_check_printing: {
            label: response?.data?.ban_after_check_printing == 0 ? "No" : "Yes",
            value: response?.data?.ban_after_check_printing,
          },
          ban_after_range_check_book: {
            label:
              response?.data?.ban_after_range_check_book == 0 ? "No" : "Yes",
            value: response?.data?.ban_after_range_check_book,
          },
          ban_check_printing: {
            label: response?.data?.ban_check_printing == 0 ? "No" : "Yes",
            value: response?.data?.ban_check_printing,
          },
          ban_bank_name: {
            label: response?.data?.ban_bank_name?.label,
            value: response?.data?.ban_bank_name?.id,
          },
          mail_country: {
            label: response?.data?.mail_country?.name,
            value: response?.data?.mail_country?.id,
          },
          balance_type: {
            label: response?.data?.balance_type == "debit" ? "Debit" : "Credit",
            value: response?.data?.balance_type,
          },
          bill_type_id: response?.data?.bill_type_id
            ? {
                label:
                  response?.data?.bill_type_id == 1
                    ? "Advance"
                    : response?.data?.bill_type_id == 2
                    ? "Against Ref"
                    : response?.data?.bill_type_id == 3
                    ? "New Ref"
                    : "On Account",
                value: response?.data?.bill_type_id,
              }
            : null,
          bill_date: response?.data?.bill_date
            ? moment(response?.data?.bill_date)?.format("YYYY-MM-DD")
            : null,
          vat_cal: response?.data?.vat_cal
            ? {
                value: response?.data?.vat_cal,
                label:
                  response?.data?.vat_cal == 1
                    ? "On Total Amount"
                    : "On Sub-total",
              }
            : null,
          duty_type: response?.data?.duty_type
            ? {
                label: capitalize(response?.data?.duty_type),
                value: response?.data?.duty_type,
              }
            : null,

          suppliers_code: response?.data?.supplier?.suppliers_code,
          email_id: response?.data?.supplier?.email_id,
          contact_number:
            response?.data?.supplier?.contact_number == null
              ? ""
              : response?.data?.supplier?.contact_number,
          vat_no: response?.data?.supplier?.vat_no,
          trade_licence_no: response?.data?.supplier?.trade_licence_no,
          po_box_no: response?.data?.supplier?.po_box_no,
          address: response?.data?.supplier?.address,
          is_subcontractor:
            response?.data?.supplier?.is_subcontractor === 1 ? true : false,
          vat_document_expiry_date:
            response?.data?.supplier?.vat?.[0]?.expiry_date,
          trade_document_expiry_date:
            response?.data?.supplier?.trade?.[0]?.expiry_date,
          payment_mode: {
            value: response?.data?.supplier?.payment?.id,
            label: response?.data?.supplier?.payment?.name,
          },
          creditperiod: response?.data?.credit_period?.id
            ? {
                value: response?.data?.credit_period?.id,
                id: response?.data?.credit_period?.id,
                label:
                  response?.data?.credit_period?.period == 0
                    ? "Immediate"
                    : `${response?.data?.credit_period?.period} ${
                        response?.data?.credit_period?.unit == "days"
                          ? response?.data?.credit_period?.period > 1
                            ? "Days"
                            : "Day"
                          : response?.data?.credit_period?.period > 1
                          ? "Months"
                          : "Months"
                      }`,
                ...response?.data?.credit_period,
              }
            : response?.data?.creditperiod
            ? response?.data?.creditperiod
            : {
                value: response?.data?.supplier?.creditperiod?.id,
                id: response?.data?.supplier?.creditperiod?.id,
                label: response?.data?.supplier?.creditperiod?.label,
              },
          country_id: {
            value: response?.data?.supplier?.country?.id,
            label: response?.data?.supplier?.country?.name,
          },
          country_id_1: {
            value: response?.data?.supplier?.country?.country?.id,
            label: response?.data?.supplier?.country?.country?.name,
          },
          currency_id: {
            value: response?.data?.supplier?.currency?.id,
            label: response?.data?.supplier?.currency?.currency_code,
          },
          state_id: response?.data?.state_id
            ? {
                label: response?.data?.state?.name,
                value: response?.data?.state?.id,
              }
            : null,
        })
        console.log(`hiii`, getValues())
      }
    }

    if (id) {
      handleEdit(id)
    }
  }, [id])

  // The Interest Calculation checkbox is state-controlled (checked={interestCalculation}, no
  // register), so the form value yup validates can drift from what's ticked — e.g. selecting a
  // nature that inherits interest sets the state but not the value, then unticking leaves the
  // value stale. That makes cal_per (Calculation %) stay "required" for a hidden field and
  // silently blocks Save. Keep the form value in lockstep with the checkbox state.
  useEffect(() => {
    setValue("is_interest_calculation", interestCalculation)
  }, [interestCalculation])

  const groupId = watch("account_group_id")?.value
  // Per-nature feature flags (configured in Developer → Ledger Features; defaults seeded from
  // the legacy hard-coded logic). Drives which feature checkboxes/sections the form shows.
  const grp = watch("account_group_id") || {}
  const feat = {
    billWise: !!Number(grp.feat_bill_wise),
    taxable: !!Number(grp.feat_taxable),
    interest: !!Number(grp.feat_interest),
    taxReg: !!Number(grp.feat_tax_registration),
    subledger: !!Number(grp.feat_subledger),
  }
  // Group-id match that also walks the parent chain, so a child group's ledger form
  // shows exactly the same tax-registration fields as its parent (e.g. a "Camp Supplier"
  // group under Sundry Creditors behaves like Sundry Creditors).
  const groupIn = ids => {
    const g = watch("account_group_id")
    if (ids.includes(Number(g?.value))) return true
    const parents = Array.isArray(g?.parent_ids) ? g.parent_ids : []
    return parents.some(pid => ids.includes(Number(pid)))
  }

  const getUniqueCode = async () => {
    let codeType = ""
    let model = ""
    let fieldName = ""

    if (groupId === 13) {
      codeType = "customer_code"
      model = "Customers"
      fieldName = "customer_code"
    } else if (groupId === 22) {
      codeType = "suppliers_code"
      model = "Suppliers"
      fieldName = "suppliers_code"
    }

    const response = await getCode(codeType, model, model)
    if (!id) {
      setValue(fieldName, response?.code?.code)
    }
    setValue("code_edit", response?.code?.manualoverride)
  }
  useEffect(() => {
    if (groupId !== 13 && groupId !== 22) return

    getUniqueCode()
  }, [groupId])

  // const calculateCreditDebitDifference = (entries = []) => {
  //   let totalCredit = 0
  //   let totalDebit = 0

  //   entries.forEach(({ amount = 0, type }) => {
  //     const amt = Number(amount) || 0
  //     const typeChk = type?.value

  //     if (typeChk === "credit") {
  //       totalCredit += amt
  //     } else if (typeChk === "debit") {
  //       totalDebit += amt
  //     }
  //   })

  //   return {
  //     totalCredit,
  //     totalDebit,
  //     difference: Math.abs(totalCredit - totalDebit),
  //   }
  // }

  const calculateCreditDebitDifference = (entries = []) => {
    let totalCredit = 0
    let totalDebit = 0

    entries.forEach(({ amount = 0, type }) => {
      const amt = Number(amount) || 0
      const typeChk = type?.value

      if (typeChk === "credit") {
        totalCredit += amt
      } else if (typeChk === "debit") {
        totalDebit += amt
      }
    })

    totalCredit = Number(totalCredit.toFixed(desimalrange || 2))
    totalDebit = Number(totalDebit.toFixed(desimalrange || 2))
    const difference = Number(
      Math.abs(totalCredit - totalDebit).toFixed(desimalrange || 2)
    )

    return {
      totalCredit,
      totalDebit,
      difference,
    }
  }

  const onKeyDown = event => {
    const targetName = event.target.name

    const isTargetField = /^voucher_contra_partial_pay\.\d+\.(amount)$/.test(
      targetName
    )

    if (!isTargetField) return

    const data = getValues()
    // event.preventDefault()
    const totalCheck = calculateCreditDebitDifference(
      data?.voucher_contra_partial_pay || []
    )

    console.log(
      `opppp`,
      Number(
        data?.balance_type?.value == "debit"
          ? Number(totalCheck?.totalDebit || 0) -
              Number(totalCheck?.totalCredit || 0)
          : Number(totalCheck?.totalCredit || 0) -
              Number(totalCheck?.totalDebit || 0)
      )
    )

    if (event.key === "Tab") {
      if (isModal) {
        const data = getValues()
        event.preventDefault()
        const totalCheck = calculateCreditDebitDifference(
          data?.voucher_contra_partial_pay || []
        )
        if (
          Number(data?.opening_balance || 0) -
            Number(
              data?.balance_type?.value == "debit"
                ? Number(totalCheck?.totalDebit || 0) -
                    Number(totalCheck?.totalCredit || 0)
                : Number(totalCheck?.totalCredit || 0) -
                    Number(totalCheck?.totalDebit || 0)
            ).toFixed(desimalrange || 2) !=
            0 &&
          isModal
        ) {
          // setModal(true)
          if (
            Number(data?.opening_balance) -
              Number(
                data?.balance_type?.value == "debit"
                  ? Number(totalCheck?.totalDebit || 0) -
                      Number(totalCheck?.totalCredit || 0)
                  : Number(totalCheck?.totalCredit || 0) -
                      Number(totalCheck?.totalDebit || 0)
              ).toFixed(desimalrange || 2) !=
            0
          ) {
            contraPartialListAppend({
              account_id: data?.credit_id?.value,
              debit: 0,
              credit: 0,
              amount: Math.abs(
                Number(watch("opening_balance")) -
                  Number(
                    data?.balance_type?.value == "debit"
                      ? Number(totalCheck?.totalDebit || 0) -
                          Number(totalCheck?.totalCredit || 0)
                      : Number(totalCheck?.totalCredit || 0) -
                          Number(totalCheck?.totalDebit || 0)
                  )
              ).toFixed(desimalrange || 2),
              type:
                data?.balance_type?.value == "debit" &&
                Number(
                  Number(totalCheck?.totalDebit || 0) -
                    Number(totalCheck?.totalCredit || 0)
                ).toFixed(desimalrange || 2) <
                  Number(data?.opening_balance || 0)
                  ? { label: "Dr", value: "debit" }
                  : data?.balance_type?.value == "credit" &&
                    Number(
                      Number(totalCheck?.totalCredit || 0) -
                        Number(totalCheck?.totalCredit || 0)
                    ).toFixed(desimalrange || 2) <
                      Number(data?.opening_balance || 0)
                  ? { label: "Cr", value: "credit" }
                  : data?.balance_type?.value == "debit" &&
                    Number(
                      Number(totalCheck?.totalDebit || 0) -
                        Number(totalCheck?.totalCredit || 0)
                    ).toFixed(desimalrange || 2) >
                      Number(data?.opening_balance || 0)
                  ? { label: "Cr", value: "credit" }
                  : { label: "Dr", value: "debit" },
              due_date: moment("31-12-2024", "DD-MM-YYYY")
                .add(
                  watch("creditperiod")?.value_in_days != null &&
                    watch("creditperiod")?.value_in_days != 0
                    ? Number(watch("creditperiod")?.value_in_days)
                    : 30,
                  "days"
                )
                .toDate(),
              date: moment("31-12-2024", "DD-MM-YYYY").toDate(),
              ref_id: {
                label: "New Ref",
                value: 3,
              },
            })
          }
        } else {
          return
        }
      }
    }
  }
  console.log(
    `veRemove`,
    watch("creditperiod")?.value_in_days,
    moment("31-12-2024", "DD-MM-YYYY")
      .add(
        watch("creditperiod")?.value_in_days != null &&
          watch("creditperiod")?.value_in_days != 0
          ? Number(watch("creditperiod")?.value_in_days)
          : 30,
        "days"
      )
      .toDate()
  )

  const handleRegistration = async data => {
    console.log(`data--`, data)

    const totalCheck = calculateCreditDebitDifference(
      data?.voucher_contra_partial_pay || []
    )

    console.log(
      `totalCheck`,
      totalCheck,
      Number(data?.opening_balance) -
        Number(
          data?.balance_type?.value == "debit"
            ? Number(totalCheck?.totalDebit || 0) -
                Number(totalCheck?.totalCredit || 0)
            : Number(totalCheck?.totalCredit || 0) -
                Number(totalCheck?.totalDebit || 0)
        )
    )

    if (
      Number(data?.opening_balance) > 0 &&
      !isModal &&
      [13, 22, 30, 31].includes(Number(watch("account_group_id")?.value))
    ) {
      setModal(true)
      if (
        Number(data?.opening_balance) -
          Number(
            data?.balance_type?.value == "debit"
              ? Number(totalCheck?.totalDebit || 0) -
                  Number(totalCheck?.totalCredit || 0)
              : Number(totalCheck?.totalCredit || 0) -
                  Number(totalCheck?.totalDebit || 0)
          ).toFixed(desimalrange || 2) !=
        0
      ) {
        contraPartialListAppend({
          account_id: data?.credit_id?.value,
          debit: 0,
          credit: 0,
          amount: Math.abs(
            Number(watch("opening_balance")) -
              // Number(totalCheck?.difference || 0)
              Number(
                data?.balance_type?.value == "debit"
                  ? Number(totalCheck?.totalDebit || 0) -
                      Number(totalCheck?.totalCredit || 0)
                  : Number(totalCheck?.totalCredit || 0) -
                      Number(totalCheck?.totalDebit || 0)
              )
          ).toFixed(desimalrange || 2),
          type: data?.balance_type?.value
            ? {
                label: data?.balance_type?.value == "debit" ? "Dr" : "Cr",
                value: data?.balance_type?.value,
              }
            : { label: "Cr", value: "credit" },
          // Number(data?.opening_balance) < Number(totalCheck?.difference)
          //   ? { label: "Dr", value: "debit" }
          //   : { label: "Cr", value: "credit" },
          due_date: moment("31-12-2024", "DD-MM-YYYY")
            .add(
              watch("creditperiod")?.value_in_days != null &&
                watch("creditperiod")?.value_in_days != 0
                ? Number(watch("creditperiod")?.value_in_days)
                : 30,
              "days"
            )
            .toDate(),
          date: moment("31-12-2024", "DD-MM-YYYY").toDate(),
          ref_id: {
            label: "New Ref",
            value: 3,
          },
        })
      }
    } else if (
      Number(data?.opening_balance || 0) -
        Number(
          data?.balance_type?.value == "debit"
            ? Number(totalCheck?.totalDebit || 0) -
                Number(totalCheck?.totalCredit || 0)
            : Number(totalCheck?.totalCredit || 0) -
                Number(totalCheck?.totalDebit || 0)
        ).toFixed(desimalrange || 2) !=
        0 &&
      isModal
    ) {
      // setModal(true)
      if (
        Number(data?.opening_balance) -
          Number(
            data?.balance_type?.value == "debit"
              ? Number(totalCheck?.totalDebit || 0) -
                  Number(totalCheck?.totalCredit || 0)
              : Number(totalCheck?.totalCredit || 0) -
                  Number(totalCheck?.totalDebit || 0)
          ).toFixed(desimalrange || 2) !=
        0
      ) {
        contraPartialListAppend({
          account_id: data?.credit_id?.value,
          debit: 0,
          credit: 0,
          amount: Math.abs(
            Number(watch("opening_balance")) -
              // Number(totalCheck?.difference || 0)
              Number(
                data?.balance_type?.value == "debit"
                  ? Number(totalCheck?.totalDebit || 0) -
                      Number(totalCheck?.totalCredit || 0)
                  : Number(totalCheck?.totalCredit || 0) -
                      Number(totalCheck?.totalDebit || 0)
              )
          ).toFixed(desimalrange || 2),
          // type:
          //   data?.balance_type?.value == "debit" &&
          //   Number(
          //     Number(totalCheck?.totalDebit || 0) -
          //       Number(totalCheck?.totalCredit || 0)
          //   ).toFixed(desimalrange || 2) !=
          //     Number(data?.opening_balance || 0).toFixed(desimalrange || 2)
          //     ? { label: "Dr", value: "debit" }
          //     : data?.balance_type?.value == "credit" &&
          //       Number(
          //         Number(totalCheck?.totalCredit || 0) -
          //           Number(totalCheck?.totalDebit || 0)
          //       ).toFixed(desimalrange || 2) <
          //         Number(data?.opening_balance || 0).toFixed(desimalrange || 2)
          //     ? { label: "Cr", value: "credit" }
          //     : data?.balance_type?.value == "debit" &&
          //       Number(totalCheck?.totalDebit || 0) >
          //         Number(data?.opening_balance || 0)
          //     ? { label: "Cr", value: "credit" }
          //     : { label: "Dr", value: "debit" },

          type:
            data?.balance_type?.value == "debit" &&
            Number(
              Number(totalCheck?.totalDebit || 0) -
                Number(totalCheck?.totalCredit || 0)
            ).toFixed(desimalrange || 2) < Number(data?.opening_balance || 0)
              ? { label: "Dr", value: "debit" }
              : data?.balance_type?.value == "credit" &&
                Number(
                  Number(totalCheck?.totalCredit || 0) -
                    Number(totalCheck?.totalCredit || 0)
                ).toFixed(desimalrange || 2) <
                  Number(data?.opening_balance || 0)
              ? { label: "Cr", value: "credit" }
              : data?.balance_type?.value == "debit" &&
                Number(
                  Number(totalCheck?.totalDebit || 0) -
                    Number(totalCheck?.totalCredit || 0)
                ).toFixed(desimalrange || 2) >
                  Number(data?.opening_balance || 0)
              ? { label: "Cr", value: "credit" }
              : { label: "Dr", value: "debit" },

          // Number(data?.opening_balance) < Number(totalCheck?.difference)
          //   ? { label: "Dr", value: "debit" }
          //   : { label: "Cr", value: "credit" },
          // type:
          //   Number(data?.opening_balance) < Number(totalCheck?.difference)
          //     ? { label: "Dr", value: "debit" }
          //     : { label: "Cr", value: "credit" },
          due_date: moment("31-12-2024", "DD-MM-YYYY")
            .add(
              watch("creditperiod")?.value != null
                ? watch("creditperiod")?.value
                : 30,
              "days"
            )
            .toDate(),
          date: moment("31-12-2024", "DD-MM-YYYY").toDate(),
          ref_id: {
            label: "New Ref",
            value: 3,
          },
        })
      }
    } else {
      const voucherEntry = data?.voucher_contra_partial_pay?.map(item => ({
        voucher_id: 20,
        ref_number: item?.code,
        due_date: moment(item?.due_date).format("YYYY-MM-DD"),
        date: moment(item?.date).format("YYYY-MM-DD"),
        amount: item?.amount,
        type: item?.type?.value,
        voucherType: "Opening Balance",
        voucher_entry_id: item?.voucher_entry_id,
      }))
      let voucherRemove = []
      if (
        Number(data?.opening_balance || 0) == 0 &&
        data?.voucher_contra_partial_pay?.length
      ) {
        voucherRemove = data?.voucher_contra_partial_pay?.map(
          dt => dt?.voucher_entry_id
        )
      }
      // let vEntry = []
      // if (Number(data?.opening_balance) > 0 && data?.voucher_contra_partial_pay?.length && ![13, 22].includes(Number(watch("account_group_id")?.value))){
      //   vEntry = [{

      //   }]
      // }
      const {
        state,
        voucher_contra_partial_pay,
        journal_entries_details,
        // interest-calculation fields must NOT ride along raw (react-select objects) —
        // they are re-added as scalars below, and only when Interest Calculation is on.
        cc_credit_period,
        calculation_type,
        cal_per,
        ...dataWithoutState
      } = data
      try {
        setIsLoading(true)
        const createdLedger = await postFinanceLedger({
          ...dataWithoutState,
          voucherEntry: voucherEntry,
          delete_entry: voucherRemove?.length ? voucherRemove : veRemove,
          vat_no: data?.trn ? data?.trn : "",
          serviece_type: data?.serviece_type?.value
            ? data?.serviece_type?.value
            : 0,
          bill_date: null,
          closing_date: null,
          state_id: data?.state_id?.value,
          vat_type: data?.vat_type?.value ? data?.vat_type?.value : 0,
          ban_branch_name: data?.branch_name,
          account_group_id: data?.account_group_id?.value,
          opening_balance: data?.opening_balance ? data?.opening_balance : 0,
          ban_after_check_printing: data?.ban_after_check_printing?.value,
          ban_after_range_check_book: data?.ban_after_range_check_book?.value,
          ban_bank_name: data?.ban_bank_name?.value,
          ban_check_printing: data?.ban_check_printing?.value,
          mail_country: data?.mail_country?.value,
          vat_cal: data?.vat_cal?.value,
          is_bill_wise: billWise ? 1 : 0,
          creditperiod: data?.creditperiod?.id,
          is_vat_applicable: vatApplicable ? 1 : 0,
          // is_cost_center: costCenter ? 1 : 0,
          is_interest_calculation: isSubledgerEntry ? 0 : interestCalculation ? 1 : 0,
          // this ledger IS a subledger → save minimal, no "applicable" link
          is_subledger: isSubledgerEntry ? 1 : 0,
          is_sub_ledger: !isSubledgerEntry && subLedger ? 1 : 0,
          // "Subledger Applicable" links to the specific subledgers picked below; only those are
          // selectable at voucher entry (group model + sub_ledger_id retired).
          sub_ledger_id: null,
          subledger_group_id: null,
          // only a subledger can nest under another subledger
          parent_subledger_id: isSubledgerEntry
            ? data?.parent_subledger_id?.value ?? null
            : null,
          subledger_ids:
            !isSubledgerEntry && subLedger
              ? (getValues("subledger_ids") || []).map(o => o.value)
              : [],
          nature_of_transaction: data?.nature_of_transaction?.value,
          vat_registration_date: data?.vat_registration_date
            ? moment(data?.vat_registration_date)?.format("YYYY-MM-DD")
            : null,
          duty_type: data?.duty_type?.value,
          is_subcontractor: data?.is_subcontractor ? 1 : 0,
          payment_mode: data?.payment_mode?.value,
          creditperiod: data?.creditperiod?.id,
          country_id: data?.country_id?.value,
          country_id_1: data?.country_id_1?.value,
          currency_id: data?.currency_id?.value,
          // account_group_id: data?.account_group_id?.value,
          balance_type: data?.balance_type?.value,
          opening_balance: data?.opening_balance ? data?.opening_balance : 0,
          vat_document_expiry_date: data?.vat_document_expiry_date
            ? moment(data?.vat_document_expiry_date).format("YYYY-MM-DD")
            : "",
          trade_document_expiry_date: data?.trade_document_expiry_date
            ? moment(data?.trade_document_expiry_date).format("YYYY-MM-DD")
            : "",
          ...(typeof vatFile != "string" && { vat_document: vatFile }),
          ...(typeof tradeFile != "string" && { trade_document: tradeFile }),
          ...(typeof vendorFile != "string" && { vendor_document: vendorFile }),
          ...(data?.account_group_id?.value == 13 ? {
            customer_code: data?.customer_code,
            customer_type: data?.customer_type?.id,
            customer_name: data?.name,
            email_id: data?.email_id,
            contact_person: data?.contact_person,
            customer_number: data?.customer_number,
            contact_person_designation: data?.contact_person_designation,
            contact_person_two: data?.contact_person_two,
            customer_number_two: data?.customer_number_two,
            contact_person_designation_two:
              data?.contact_person_designation_two,
          } : {}),
          ...(interestCalculation && {
            cc_credit_period: data?.cc_credit_period?.id,
            calculation_type: data?.calculation_type?.id,
            cal_per: data?.cal_per,
          }),
          ...(data?.opening_balance > 0 && {
            balance_type: data?.balance_type?.value,
            bill_no: data?.bill_no,
            bill_type_id: data?.bill_type_id?.value,
            // bill_date: moment(data?.bill_date)?.format("YYYY-MM-DD"),
            // closing_date: moment(data?.closing_date)?.format("YYYY-MM-DD"),
          }),
          // ...(typeof vatFile != "string" && { vat_document: vatFile }),
          // ...(typeof tradeFile != "string" && { trade_document: tradeFile }),
          // ...(typeof vendorFile != "string" && { vendor_document: vendorFile }),
          // ...(data?.account_group_id == 22 && {
          //   is_subcontractor: data?.is_subcontractor ? 1 : 0,
          //   payment_mode: data?.payment_mode?.value,
          //   creditperiod: data?.creditperiod?.id,
          //   country_id: data?.country_id?.value,
          //   country_id_1: data?.country_id_1?.value,
          //   currency_id: data?.currency_id?.value,
          //   // account_group_id: data?.account_group_id?.value,
          //   balance_type: data?.balance_type?.value,
          //   opening_balance: data?.opening_balance ? data?.opening_balance : 0,
          //   vat_document_expiry_date: data?.vat_document_expiry_date
          //     ? moment(data?.vat_document_expiry_date).format("YYYY-MM-DD")
          //     : "",
          //   trade_document_expiry_date: data?.trade_document_expiry_date
          //     ? moment(data?.trade_document_expiry_date).format("YYYY-MM-DD")
          //     : "",
          //   ...(typeof vatFile != "string" && { vat_document: vatFile }),
          //   ...(typeof tradeFile != "string" && { trade_document: tradeFile }),
          //   ...(typeof vendorFile != "string" && { vendor_document: vendorFile }),
          // }),
        })

        toastSuccess(createdLedger?.message)
        onSuccess(createdLedger)
        if (isOffcanvas) {
          const updatedLedgers = await fetchFinanceLedgersLi(
            data?.account_group_id?.value
          )

          console.log("Updated Ledgers:", updatedLedgers?.data)
        }

        onSuccess(createdLedger)
        if (!isOffcanvas) {
          // land back on the tab the record belongs to, so a new subledger is visible straight away
          navigate("/finance-ledger", { state: { openTab: isSubledgerEntry ? "subledgers" : "ledgers" } })
        }
      } catch (err) {
        toastError(err?.message)
        onError(err)
      } finally {
        setIsLoading(false)
      }
    }
  }

  const {
    fields: contraFieldsPartial,
    append: contraPartialListAppend,
    remove: contraPartialListRemove,
  } = useFieldArray({
    control,
    name: "voucher_contra_partial_pay",
  })

  const handleNOA = e => {
    console.log(`handleNOA`, e)

    const values = getValues()
    
    reset({
      balance_type: values?.balance_type,
      account_group_id: values?.account_group_id,
      name: values?.name,
      opening_balance: values?.opening_balance,
      id: values?.id,
    })

    if ([1, 4].includes(Number(e?.type?.id))) {
      setValue("balance_type", { label: "Debit", value: "debit" })
    } else if ([2, 3].includes(Number(e?.type?.id))) {
      setValue("balance_type", { label: "Credit", value: "credit" })
    }

    // Bill-wise defaults ON when the nature's configured flag says so (Developer → Ledger
    // Features — inherited by child groups), with the legacy hard-coded groups kept as a
    // fallback for anything configured before the flags existed.
    const allowed = [13, 22, 30, 31]
    const parentIds = Array.isArray(e?.parent_ids) ? e.parent_ids.map(Number) : [Number(e?.parent_ids)]

    const shouldBillWise =
      !!Number(e?.feat_bill_wise) ||
      allowed.includes(Number(e?.value)) ||
      parentIds.some(id => allowed.includes(id))

    setBillWise(shouldBillWise)
    // Pre-tick the remaining features from the nature's configured flags too —
    // the user can still untick them per ledger.
    setVatApplicable(!!Number(e?.feat_taxable))
    setInterestCalculation(!!Number(e?.feat_interest))
    setSubLedger(!!Number(e?.feat_subledger))
  }

  const toggleSelect = () => setModal(!isModal)

  //   const toggleSelectModal = () => {

  //     console.log(`watch("voucher_contra_partial_pay")`, watch("voucher_contra_partial_pay"));

  //     const removeIds = watch("voucher_contra_partial_pay")?.map((item, i) => i)
  //     removeIds &&
  //       removeIds?.length > 1 &&
  //       removeIds?.map(i => contraPartialListRemove(i))
  //     // setValue(`voucher_contra.${viewData?.currIndex}.account_id`, null)
  //     // setValue(`voucher_contra.${viewData?.currIndex}.partial_payments`, [])
  //     // setValue(`voucher_contra.${viewData?.currIndex}.account_id`, null)
  // console.log(`removeIds`, removeIds);

  //     setModal(!isModal)
  //   }

  const toggleSelectModal = () => {
    if (id) {
      setModal(!isModal)
      return
    }

    if (!id) {
      setValue(`voucher_contra_partial_pay`, [])
    }

    const removeIds = watch("voucher_contra_partial_pay")?.map((_, i) => i)

    if (removeIds?.length > 1) {
      ;[...removeIds].reverse().forEach(index => contraPartialListRemove(index))
    }

    console.log(`removeIds`, removeIds)
    setModal(!isModal)
  }
  console.log(
    `watch("voucher_contra_partial_pay")`,
    watch("voucher_contra_partial_pay")
  )

  const handleBank = e => {
    setValue("ban_iban", e?.iban_code ? e?.iban_code : "")
    setValue("swift_code", e?.swift_code ? e?.swift_code : "")
  }

  const handleBillWiseCheck = dt => {
    setBillWise(!dt)
  }

  // const handleOpeningBalanceCheck = dt => {
  //   setOpeningBalance(!dt)
  //   setValue("is_opening_balance", !dt, { shouldValidate: true })
  // }

  const handleVatCheck = dt => {
    setVatApplicable(!dt)
  }

  const handlePartialRemove = e => {
    setVERemove(prevVERemove => [...prevVERemove, e])
  }

  const handleInterestCheck = dt => {
    setInterestCalculation(!dt)
    setValue("is_interest_calculation", !dt, { shouldValidate: true })
  }

  const handleSubLedgerCheck = dt => {
    setSubLedger(!dt)
    if (dt) setValue("subledger_ids", []) // unchecking clears the chosen subledgers
  }

  const onVatChange = event => {
    setVatFile(event?.target?.files?.[0])
  }
  const onVendorChange = event => {
    setVendorFile(event?.target?.files?.[0])
  }

  const onTradeChange = event => {
    setTradeFile(event?.target?.files?.[0])
  }

  const handleCheck = e => {
    if (e?.target?.checked) {
      setValue("is_subcontractor", true)
      getUniqueCode("suppliers_code", "Suppliers", "Subcontract")
    } else {
      setValue("is_subcontractor", false)
      getUniqueCode("suppliers_code", "Suppliers", "Suppliers")
    }
  }

  const [showGroupModal, setShowGroupModal] = useState(false)
  // Form content that can be rendered in both normal and offcanvas modes
  const formContent = (
    <FormProvider>
      <Form
        id="ledger-form"
        onSubmit={e => {
          e.preventDefault()
          e.stopPropagation()
          handleSubmit(handleRegistration)(e)
        }}
      >
        {!isOffcanvas && (
          <div className="w-100">
            <div className="d-flex justify-content-between pe-3">
              <Breadcrumbs
                title="Procurement"
                breadcrumbObject={[
                  { title: "Finance", link: "/finance" },
                  { title: crumb || "", link: "#" },
                  { title: "Ledgers", link: "/finance-ledger" },
                  {
                    title: id ? "Edit Ledger" : "Add Ledger",
                    link: "",
                  },
                ]}
              />
              <LoadingButton
                form={formId}
                color={"primary"}
                loading={isLoading}
                disabled={isLoading}
                className={"px-2 mb-3 btn btn-primary"}
                type="submit"
              >
                {resolvedLedgerId ? "Update" : "Save"}
              </LoadingButton>
            </div>
          </div>
        )}
        <Container fluid className="ps-lg-0">
          <Card className="invoice-main-card px-3 pb-3">
            {!isOffcanvas && (
              <div className="mapping-setup-title mb-2 pt-3 edittheamtitle">
                {isSubledgerEntry ? "Create Subledger" : "Create Ledger"}
              </div>
            )}

            <Row className="mb-4 mt-2">
              <Col sm={12}>
                <Row>
                  <Col lg={3}>
                    <FormGroup>
                      <Label>
                        Ledger Name<span className="mandatory">*</span>
                      </Label>
                      <UFInput
                        control={control}
                        placeholder="Enter the Ledger Name"
                        name={"name"}
                        invalid={!!errors.name}
                      />
                      <FormFeedback invalid>
                        {errors.name?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  {!isSubledgerEntry && (
                  <Col lg={3}>
                    <FormGroup>
                      <Label>
                        Nature Of Account
                        <span className="mandatory">*</span>
                      </Label>
                      <FinanceGroupType
                        control={control}
                        placeholder="Select the Nature Of Account"
                        name={"account_group_id"}
                        invalid={!!errors.account_group_id}
                        target={"body"}
                        showCreateOption={true}
                        onCreate={() => setShowGroupModal(true)}
                        onSelectChange={e => handleNOA(e)}
                        refreshKey={showGroupModal}
                        parentChk={defaultGroupId}
                      />
                      <EditFinanceGroup
                        buttonLabel=""
                        className=""
                        show={showGroupModal}
                        onReset={() => setShowGroupModal(false)}
                        onUpdate={newGroup => {
                          setShowGroupModal(false)
                          if (newGroup) {
                            setValue(
                              "account_group_id",
                              {
                                label: newGroup.name,
                                value: newGroup.id,
                              },
                              { shouldValidate: true }
                            )
                          }
                        }}
                      />
                      <FormFeedback invalid>
                        {errors.account_group_id?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  )}
                  {/* No "is SubLedger" toggle here: which kind of record this is comes from where
                      you started — the Ledgers tab creates a ledger, the Subledgers tab's
                      "+ Subledger" arms subledger mode, and an edit takes it from the record. */}
                  {/* Optional nesting: leave empty for a top-level subledger. Only top-level
                      subledgers are offered, so the tree stays one level deep. */}
                  {isSubledgerEntry && (
                    <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>Parent Subledger</Label>
                        <ParentSubledgerLi
                          control={control}
                          name={"parent_subledger_id"}
                          placeholder="Select parent subledger"
                          target="body"
                          excludeId={resolvedLedgerId}
                        />
                      </FormGroup>
                    </Col>
                  )}
                  {!isSubledgerEntry && watch("account_group_id")?.value == 13 && (
                    <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>Customer Code</Label>
                        <UFInput
                          control={control}
                          placeholder=""
                          name={"customer_code"}
                          invalid={!!errors.customer_code}
                          disabled={
                            watch("code_edit") == 0 ||
                            watch("code_edit") == undefined
                              ? true
                              : false
                          }
                        />
                        <FormFeedback invalid>
                          {errors.customer_code?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                  )}
                  {watch("account_group_id")?.value == 22 && (
                    <Col sm={3}>
                      <FormGroup className="mb-3">
                        <Label>Supplier Code</Label>
                        <UFInput
                          control={control}
                          placeholder=""
                          name={"suppliers_code"}
                          invalid={!!errors.suppliers_code}
                          disabled={
                            watch("code_edit") == 0 ||
                            watch("code_edit") == undefined
                              ? true
                              : false
                          }
                        />
                        <FormFeedback invalid>
                          {errors.suppliers_code?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                  )}

                  {([13, 22, 30, 31]?.includes(watch("account_group_id")?.value) ||
                    [13, 22, 30, 31].some(id =>
                      watch("account_group_id")?.parent_ids?.includes(id)
                    )) && (
                    <Col sm={3}>
                      <FormGroup className="mb-3">
                        <Label>
                          Credit Period
                          {/* <span className="mandatory">*</span> */}
                        </Label>
                        <CreditPaymentMethod
                          control={control}
                          placeholder="select"
                          name={"creditperiod"}
                          invalid={!!errors.creditperiod}
                          target={"body"}
                        />
                        <FormFeedback invalid>
                          {errors.creditperiod?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                  )}
                </Row>
              </Col>
            </Row>
            {!isSubledgerEntry && (
            <>
            <hr className="m-0" />
            <Row className="">
              <Col sm={12}>
                <Accordion
                  open={openAccordions}
                  toggle={toggleAccordion}
                  stayOpen
                >
                  {/* <UncontrolledAccordion defaultOpen={openAccordions} stayOpen> */}
                  {/* {bankCheck ? ( */}
                  {watch("account_group_id")?.value &&
                    (feat.billWise || feat.taxable || feat.interest) && (
                      <AccordionItem>
                        <AccordionHeader targetId="8">
                          <span className="edittheamtitle">Features</span>
                        </AccordionHeader>
                        <AccordionBody accordionId="8">
                          <Row>
                            {feat.billWise && (
                              <Col
                                lg={"auto"}
                                onClick={() => handleBillWiseCheck(billWise)}
                                className="mt-auto"
                              >
                                <FormGroup className="mt-2">
                                  <input
                                    type="checkbox"
                                    className="ever-rise-checkbox"
                                    name={"is_bill_wise"}
                                    checked={billWise}
                                  />
                                  <Label className="ms-2">
                                    Bill Wise Detail
                                  </Label>
                                </FormGroup>
                              </Col>
                            )}
                            {feat.taxable && (
                              <Col
                                lg={"auto"}
                                onClick={() => handleVatCheck(vatApplicable)}
                                className="mt-auto"
                              >
                                <FormGroup className="mt-2">
                                  <input
                                    type="checkbox"
                                    className="ever-rise-checkbox"
                                    name={"is_vat_applicable"}
                                    checked={vatApplicable}
                                  />
                                  <Label className="ms-2">Taxable</Label>
                                </FormGroup>
                              </Col>
                            )}
                            {/* {([27, 24, 28, 25, 2, 4, 13, 22].includes(
                              Number(watch("account_group_id")?.value)
                            ) ||
                              [1, 2, 3, 4].includes(
                                Number(watch("account_group_id")?.type?.id)
                              )) && (
                              <Col
                                lg={"auto"}
                                onClick={() =>
                                  handleCostCenterCheck(costCenter)
                                }
                                className="mt-auto"
                              >
                                <FormGroup className="mt-2">
                                  <input
                                    type="checkbox"
                                    className="ever-rise-checkbox"
                                    name={"is_cost_center"}
                                    checked={costCenter}
                                  />
                                  <Label className="ms-2">Cost Center</Label>
                                </FormGroup>
                              </Col>
                            )} */}
                            {feat.interest && (
                              <Col
                                lg={"auto"}
                                onClick={() =>
                                  handleInterestCheck(interestCalculation)
                                }
                                className="mt-auto"
                              >
                                <FormGroup className="mt-2">
                                  <input
                                    type="checkbox"
                                    className="ever-rise-checkbox"
                                    name={"is_interest_calculation"}
                                    checked={interestCalculation}
                                  />
                                  <Label className="ms-2">
                                    Interest Calculation
                                  </Label>
                                </FormGroup>
                              </Col>
                            )}
                            {feat.subledger && (
                              <Col
                                lg={"auto"}
                                onClick={() => handleSubLedgerCheck(subLedger)}
                                className="mt-auto"
                              >
                                <FormGroup className="mt-2">
                                  <input
                                    type="checkbox"
                                    className="ever-rise-checkbox"
                                    name={"is_sub_ledger"}
                                    checked={subLedger}
                                  />
                                  <Label className="ms-2">
                                    Subledger Applicable
                                  </Label>
                                </FormGroup>
                              </Col>
                            )}
                          </Row>
                          {subLedger && (
                            <Row>
                              <Col sm={4}>
                                <FormGroup className="mb-3">
                                  <Label>
                                    Subledgers
                                    <span className="mandatory">*</span>
                                    <small className="text-muted ms-1">(the ones that apply at voucher entry)</small>
                                  </Label>
                                  <SubledgersMultiLi
                                    control={control}
                                    placeholder="Select subledgers"
                                    name={"subledger_ids"}
                                    invalid={!!errors.subledger_ids}
                                    target={"body"}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                          )}
                          {interestCalculation && (
                            <Row>
                              <Col sm={3}>
                                <FormGroup className="mb-3">
                                  <Label>
                                    Credit Period
                                    <span className="mandatory">*</span>
                                  </Label>
                                  <CreditPaymentMethod
                                    control={control}
                                    placeholder="select"
                                    name={"cc_credit_period"}
                                    invalid={!!errors.cc_credit_period}
                                    target={"body"}
                                  />
                                  <FormFeedback invalid>
                                    {errors.cc_credit_period?.message}
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                              <Col sm={3}>
                                <FormGroup className="mb-4">
                                  <Label>
                                    Calculation Type
                                    <span className="mandatory">*</span>
                                  </Label>
                                  <CalcualtionTypeInterest
                                    control={control}
                                    name="calculation_type"
                                    invalid={!!errors.calculation_type}
                                    // disabled={id ? true : false}
                                    placeholder={"Select Calculation Type"}
                                  />
                                  <FormFeedback>
                                    {errors.calculation_type?.message}
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                              <Col sm={3}>
                                <FormGroup className="mb-4">
                                  <Label>
                                    Calculation Percentage
                                    <span className="mandatory">*</span>
                                  </Label>
                                  <UFInputNumber
                                    control={control}
                                    name="cal_per"
                                    invalid={!!errors.cal_per}
                                    placeholder={"Enter the Percentage"}
                                    decimalLength={desimalrange || 2}
                                    isDecimal={true}
                                    maxNum={100}
                                  />
                                  <FormFeedback>
                                    {errors.cal_per?.message}
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                            </Row>
                          )}
                        </AccordionBody>
                      </AccordionItem>
                    )}
                  <AccordionItem>
                    <AccordionHeader targetId="1">
                      <span className="edittheamtitle">
                        {feat.taxReg ? "Tax Registration Details" : "Tax Details"}
                      </span>
                    </AccordionHeader>
                    <AccordionBody accordionId="1">
                      <Row>
                        {feat.taxReg && (
                          <Col lg="3" xs={12} md={5} sm={12}>
                            <FormGroup className="mb-4">
                              <Label>
                                Registration Type
                                {/* <span className="mandatory">*</span> */}
                              </Label>
                              <VatTypesLists
                                control={control}
                                placeholder="Select"
                                name={`vat_type`}
                                invalid={!!errors?.vat_type}
                              />
                              <FormFeedback invalid>
                                {errors?.vat_type?.message}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                        )}
                        {[1, 3]?.includes(watch("vat_type")?.value) &&
                          groupIn([13, 22, 5, 30, 31]) && (
                            <Col lg="3" xs={12} md={5} sm={12}>
                              <FormGroup className="mb-4">
                                <Label>
                                  Registration Date
                                  {/* <span className="mandatory">*</span> */}
                                </Label>
                                <UFDate
                                  control={control}
                                  placeholder="Enter the Date "
                                  name={"vat_registration_date"}
                                  maxDate={moment().format("YYYY-MM-DD")}
                                />
                                <FormFeedback invalid>
                                  {errors?.vat_registration_date?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                          )}
                        {[1, 3]?.includes(watch("vat_type")?.value) &&
                          groupIn([13, 22, 5, 30, 31]) && (
                            <Col lg="3" xs={12} md={5} sm={12}>
                              <FormGroup className="mb-4">
                                <Label>
                                  TRN
                                  {/* <span className="mandatory">*</span> */}
                                </Label>
                                <UFInputNumber
                                  control={control}
                                  placeholder="Enter the TRN"
                                  name={`trn`}
                                  invalid={!!errors?.trn}
                                  maxLength={15}
                                />
                                <FormFeedback invalid>
                                  {errors?.trn?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                          )}
                        {/* <Col lg="3" xs={12} md={5} sm={12}>
                          <FormGroup className="mb-4">
                            <Label>
                              Registration Type
                            </Label>
                            <VatTypesLists
                              control={control}
                              placeholder="Select"
                              name={`vat_type`}
                              invalid={!!errors?.vat_type}
                            />
                            <FormFeedback invalid>
                              {errors?.vat_type?.message}
                            </FormFeedback>
                          </FormGroup>
                        </Col> */}
                        {groupIn([17]) ? (
                          <Col lg="3" xs={12} md={5} sm={12}>
                            <FormGroup className="mb-4">
                              <Label>
                                Type of Duty/Tax
                                {/* <span className="mandatory">*</span> */}
                              </Label>
                              <DutyTypes
                                control={control}
                                placeholder="Select"
                                name={`duty_type`}
                                invalid={!!errors?.duty_type}
                              />
                              <FormFeedback invalid>
                                {errors?.duty_type?.message}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                        ) : (
                          <></>
                        )}
                        {groupIn([17]) ? (
                          <Col lg="3" xs={12} md={5} sm={12}>
                            <FormGroup className="mb-4">
                              <Label>VAT %</Label>
                              <UFInputNumber
                                control={control}
                                placeholder="Enter the VAT %"
                                name={`vat_per`}
                                invalid={!!errors?.vat_per}
                              />
                              <FormFeedback invalid>
                                {errors?.vat_per?.message}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                        ) : (
                          <></>
                        )}
                        {groupIn([17]) ? (
                          <Col lg="3" xs={12} md={5} sm={12}>
                            <FormGroup className="mb-4">
                              <Label>
                                Method Of Calculation
                                {/* <span className="mandatory">*</span> */}
                              </Label>
                              <VatCalculationMethod
                                control={control}
                                placeholder="Select"
                                name={`vat_cal`}
                                invalid={!!errors?.vat_cal}
                              />
                              <FormFeedback invalid>
                                {errors?.vat_cal?.message}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                        ) : (
                          <></>
                        )}
                        {vatApplicable &&
                          !groupIn([13, 22, 30, 31, 5]) && (
                            <Col lg="3" xs={12} md={5} sm={12}>
                              <FormGroup className="mb-4">
                                <Label>
                                  Service Type
                                  {/* <span className="mandatory">*</span> */}
                                </Label>
                                <VatTypesLi
                                  control={control}
                                  placeholder="Select"
                                  name={`serviece_type`}
                                  invalid={!!errors?.serviece_type}
                                />
                                <FormFeedback invalid>
                                  {errors?.serviece_type?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                          )}
                        {vatApplicable == true &&
                        !groupIn([13, 22, 30, 31, 5]) ? (
                          <Col lg="3" xs={12} md={5} sm={12}>
                            <FormGroup className="mb-4">
                              <Label>
                                Nature Of Transactions
                                {/* <span className="mandatory">*</span> */}
                              </Label>
                              <NatureOfTransactions
                                control={control}
                                placeholder="Select the Nature Of Transactions"
                                name={`nature_of_transaction`}
                                invalid={!!errors?.nature_of_transaction}
                                clearable={true}
                              />
                              <FormFeedback invalid>
                                {errors?.nature_of_transaction?.message}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                        ) : (
                          <></>
                        )}
                        {vatApplicable &&
                        groupIn([13, 22, 5, 30, 31]) ? (
                          <Col lg="3" xs={12} md={5} sm={12}>
                            <FormGroup className="mb-4">
                              <Label>
                                State
                                {/* <span className="mandatory">*</span> */}
                              </Label>
                              <StateOnlyList
                                control={control}
                                placeholder="Select the State"
                                name={"state_id"}
                              />
                              <FormFeedback invalid>
                                {errors?.state_id?.message}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                        ) : (
                          <></>
                        )}
                      </Row>
                    </AccordionBody>
                  </AccordionItem>
                  {watch("account_group_id")?.value !== 17 && (
                    <AccordionItem>
                      <AccordionHeader targetId="2">
                        <span className="edittheamtitle">
                          Bank Account Details
                        </span>
                      </AccordionHeader>
                      <AccordionBody accordionId="2">
                        {/* {benefitsArr?.map((dt, i) =>
                              dt?.addons?.length ? (
                                <div key={i} className="py-1">
                                  <div onClick={() => handleValueCheck(i)}>
                                    <input
                                      control={control}
                                      type="checkbox"
                                      className="ever-rise-checkbox"
                                      name={`benefitsLi.${i}.master_id`}
                                      checked={checkboxValues[i]}
                                    />
                                    <label className="label-padding">
                                      {dt?.name ? capitalize(dt?.name) : "-"}
                                    </label>{" "}
                                  </div>
                                  <div
                                    className={`${
                                      i + 1 < benefitsListArr?.length
                                        ? "grade-control-border"
                                        : ""
                                    }`}
                                  >
                                    {checkboxValues[i] && (
                                      <Row className="pl-4 py-4 ps-3">
                                        {dt?.addons?.map((data, index) =>
                                          data?.input_type?.id == 0 ? (
                                            <Col sm={3} key={`text_${index}`}>
                                              <FormGroup className="mb-4">
                                                <Label>
                                                  {data?.label
                                                    ? capitalize(data?.label)
                                                    : "-"}
                                                  <span className="mandatory">
                                                    *
                                                  </span>
                                                </Label>
                                                <UFInput
                                                  control={control}
                                                  placeholder={data?.label}
                                                  name={`benefitsLi.${i}.addons.${index}.data`}
                                                  invalid={
                                                    !!errors[
                                                      `value_${data?.id}`
                                                    ]
                                                  }
                                                />
                                                <FormFeedback invalid>
                                                  {
                                                    errors[`value_${data?.id}`]
                                                      ?.message
                                                  }
                                                </FormFeedback>
                                              </FormGroup>
                                            </Col>
                                          ) : data?.input_type?.id == 1 ? (
                                            <Col sm={3}>
                                              <Label>
                                                {data?.label}
                                                <span className="mandatory">
                                                  *
                                                </span>
                                              </Label>
                                              <div className="d-flex flex-row align-items-center">
                                                {data?.value?.map(
                                                  (dt, index) => (
                                                    <div
                                                      key={`radio_${index}`}
                                                      className="ps-2 d-flex align-items-center"
                                                    >
                                                      <div>
                                                        <input
                                                          type="radio"
                                                          id={dt}
                                                          name={`benefitsLi.${i}.data`}
                                                          value={dt}
                                                        />
                                                         {" "}
                                                        <label htmlFor={dt}>
                                                          {dt}
                                                        </label>
                                                        <br></br>
                                                      </div>
                                                    </div>
                                                  )
                                                )}{" "}
                                              </div>
                                            </Col>
                                          ) : data?.input_type?.id == 2 ? (
                                            <Col sm={3}>
                                              {}
                                              <Label>
                                                {data?.label}
                                                <span className="mandatory">
                                                  *
                                                </span>
                                              </Label>
                                              <DynamicDropdown
                                                control={control}
                                                placeholder={data?.label}
                                                name={`benefitsLi.${i}.addons.${index}.data`}
                                                invalid={
                                                  !!errors.value_dropdown
                                                }
                                                target={"body"}
                                                arr={data?.value}
                                              />
                                            </Col>
                                          ) : (
                                            <></>
                                          )
                                        )}
                                      </Row>
                                    )}
                                  </div>
                                </div>
                              ) : null
                            )} */}{" "}
                        <Row>
                          <Col lg="3" xs={12} md={5} sm={12}>
                            <FormGroup className="mb-4">
                              <Label>Account Holder Name</Label>
                              <UFInput
                                control={control}
                                placeholder="Enter the Account Holder Name"
                                name={`ban_account_name`}
                                invalid={!!errors?.ban_account_name}
                              />
                              <FormFeedback invalid>
                                {errors?.ban_account_name?.message}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                          <Col lg="3" xs={12} md={5} sm={12}>
                            <FormGroup className="mb-4">
                              <Label>
                                Account Number
                                {/* <span className="mandatory">*</span> */}
                              </Label>
                              <UFInput
                                control={control}
                                placeholder="Enter the Account Number"
                                name={`ban_account_num`}
                                invalid={!!errors?.ban_account_num}
                              />
                              <FormFeedback invalid>
                                {errors.ban_account_num?.message}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                          <Col lg="3" xs={12} md={5} sm={12}>
                            <FormGroup className="mb-4">
                              <Label>
                                Bank Name
                                {/* <span className="mandatory">*</span> */}
                              </Label>
                              <BankList
                                control={control}
                                placeholder="Select the Bank Name"
                                name={`ban_bank_name`}
                                onSelectChange={e => handleBank(e)}
                              />
                              {/* <UFInput
                              control={control}
                              placeholder="Enter the Bank Name"
                              name={`ban_bank_name`}
                              invalid={
                                !!errors?.ban_bank_name
                              }
                            /> */}
                              <FormFeedback invalid>
                                {errors?.ban_bank_name?.message}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                          <Col lg="3" xs={12} md={5} sm={12}>
                            <FormGroup className="mb-4">
                              <Label>
                                Branch Name
                                {/* <span className="mandatory">*</span> */}
                              </Label>
                              <UFInput
                                control={control}
                                placeholder="Enter the Branch Name"
                                name={`branch_name`}
                                invalid={!!errors?.branch_name}
                              />
                              <FormFeedback invalid>
                                {errors.branch_name?.message}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                          <Col lg="3" xs={12} md={5} sm={12}>
                            <FormGroup className="mb-4">
                              <Label>
                                IBAN
                                {/* <span className="mandatory">*</span> */}
                              </Label>
                              <UFInput
                                control={control}
                                placeholder="Enter the IBAN Name"
                                name={`ban_iban`}
                                invalid={!!errors?.ban_iban}
                              />
                              <FormFeedback invalid>
                                {errors?.ban_iban?.message}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                          <Col lg="3" xs={12} md={5} sm={12}>
                            <FormGroup className="mb-4">
                              <Label>
                                SWIFT/BIC Code
                                {/* <span className="mandatory">*</span> */}
                              </Label>
                              <UFInput
                                control={control}
                                placeholder="Enter the Swift Code"
                                name={`swift_code`}
                                invalid={!!errors?.swift_code}
                              />
                              <FormFeedback invalid>
                                {errors?.swift_code?.message}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                          {/* <Col
                          lg="12"
                          xs={12}
                          md={2}
                          sm={12}
                          className="d-flex justify-content-end"
                        >
                          {accountFields.length == index + 1 ? (
                            <Button
                              color="secondary"
                              className="addButton mt-2"
                              onClick={() =>
                                accountAppend({
                                  ac_holder_name: "",
                                  ac_number: "",
                                  bank_name: null,
                                  branch_name: "",
                                  iban: "",
                                  swift_code: "",
                                })
                              }
                            >
                              Add Row
                            </Button>
                          ) : (
                            ""
                          )}
                          {accountFields.length > 1 ? (
                            <Button
                              color="primary"
                              className="removeButton mt-2 ms-3"
                              onClick={() => accountRemove(index)}
                            >
                              Delete Row
                            </Button>
                          ) : (
                            ""
                          )}
                        </Col> */}
                        </Row>
                      </AccordionBody>
                    </AccordionItem>
                  )}
                  {/* ) : (
                          <></>
                        )} */}
                  {watch("account_group_id")?.value !== 17 && (
                    <AccordionItem>
                      <AccordionHeader targetId="3" stayOpen>
                        <span className="edittheamtitle">
                          Cheque Configuration
                        </span>
                      </AccordionHeader>
                      <AccordionBody accordionId="3">
                        <Row>
                          <Col lg="3" xs={12} md={5} sm={12}>
                            <FormGroup className="mb-4">
                              <Label>After Range for Cheque Books</Label>
                              <ConfigLi
                                control={control}
                                placeholder="Select the Cheque Books"
                                name={`ban_after_range_check_book`}
                                invalid={!!errors?.ban_after_range_check_book}
                              />
                              <FormFeedback invalid>
                                {errors?.ban_after_range_check_book?.message}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                          <Col lg="3" xs={12} md={5} sm={12}>
                            <FormGroup className="mb-4">
                              <Label>Enable Cheque Printing</Label>
                              <ConfigLi
                                control={control}
                                placeholder="Select the Enable Cheque Printing"
                                name={`ban_check_printing`}
                                invalid={!!errors?.ban_check_printing}
                              />
                              <FormFeedback invalid>
                                {errors?.ban_check_printing?.message}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                          <Col lg="3" xs={12} md={5} sm={12}>
                            <FormGroup className="mb-4">
                              <Label>After Cheque Printing Configuration</Label>
                              <ConfigLi
                                control={control}
                                placeholder="Select the Printing Configuration"
                                name={`ban_after_check_printing`}
                                invalid={!!errors?.ban_after_check_printing}
                              />
                              <FormFeedback invalid>
                                {errors?.ban_after_check_printing?.message}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                        </Row>
                        {/* {entityArr?.map((dt, i) =>
                              dt?.addons?.length ? (
                                <div key={i} className="py-1">
                                  {console.log(`dt----`, dt)}
                                  <div onClick={() => handleEntityCheckbox(i)}>
                                    <input
                                      type="checkbox"
                                      className="ever-rise-checkbox"
                                      name={`entitlementListArr.${i}.master_id`}
                                      checked={entityCheckboxValues[i]}
                                    />
                                    <label className="label-padding">
                                      {dt?.name}
                                    </label>{" "}
                                  </div>
                                  <div
                                    className={`${
                                      i + 1 < entitlementListArr?.length
                                        ? "grade-control-border"
                                        : ""
                                    }`}
                                  >
                                    {entityCheckboxValues[i] && (
                                      <Row className="pl-4 pt-4 ps-3">
                                        {dt?.addons?.map((data, index) =>
                                          data?.input_type?.id == 0 ? (
                                            <Col sm={3} key={`text_${index}`}>
                                              <FormGroup className="mb-4">
                                                <Label>
                                                  {data?.label}
                                                  <span className="mandatory">
                                                    *
                                                  </span>
                                                </Label>
                                                <UFInput
                                                  control={control}
                                                  placeholder={data?.label}
                                                  name={`entityLi.${i}.addons.${index}.data`}
                                                  invalid={!!errors.name}
                                                />
                                                <FormFeedback invalid>
                                                  {errors.name?.message}
                                                </FormFeedback>
                                              </FormGroup>
                                            </Col>
                                          ) : data?.input_type?.id == 1 ? (
                                            <Col sm={3}>
                                              {data?.value?.map((dt, index) => (
                                                <div
                                                  sm={3}
                                                  key={`radio_${index}`}
                                                >
                                                  <div>
                                                    <input
                                                      type="radio"
                                                      id={dt}
                                                      name={`entityLi.${i}.addons.${index}.data`}
                                                      value={dt}
                                                    />
                                                     {" "}
                                                    <label for={dt}>{dt}</label>
                                                    <br></br>
                                                  </div>
                                                </div>
                                              ))}{" "}
                                            </Col>
                                          ) : data?.input_type?.id == 2 ? (
                                            <Col sm={3}>
                                              {}
                                              <Label>
                                                {data?.label}
                                                <span className="mandatory">
                                                  *
                                                </span>
                                              </Label>
                                              <DynamicDropdown
                                                control={control}
                                                placeholder={data?.label}
                                                name={`entityLi.${i}.addons.${index}.data`}
                                                invalid={
                                                  !!errors.value_dropdown
                                                }
                                                target={"body"}
                                                arr={data?.value}
                                              />
                                            </Col>
                                          ) : (
                                            <></>
                                          )
                                        )}
                                      </Row>
                                    )}
                                  </div>
                                </div>
                              ) : null
                            )} */}
                      </AccordionBody>
                    </AccordionItem>
                  )}
                  {watch("account_group_id")?.value !== 17 && (
                    <AccordionItem>
                      <AccordionHeader targetId="4">
                        <span className="edittheamtitle">Mailing Details</span>
                      </AccordionHeader>
                      <AccordionBody accordionId="4">
                        {watch("account_group_id")?.value == 13 ? (
                          <Row>
                            <Col sm={3}>
                              <FormGroup className="mb-4">
                                <Label>
                                  Customer Type
                                  <span className="mandatory">*</span>
                                </Label>
                                <CustomerType
                                  control={control}
                                  name="customer_type"
                                  invalid={!!errors.customer_type}
                                  disabled={id ? true : false}
                                  placeholder={"Select Customer Type"}
                                />
                                <FormFeedback>
                                  {errors.customer_type?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            {/* Rest of your form fields */}
                            {/* <Col sm={3}>
                            <FormGroup className="mb-4">
                              <Label>
                                Customer Name
                                <span className="mandatory">*</span>
                              </Label>
                              <UFInput
                                control={control}
                                placeholder="Enter the Customer Name"
                                name={"customer_name"}
                                invalid={!!errors.customer_name}
                              />
                              <FormFeedback invalid>
                                {errors.customer_name?.message}
                              </FormFeedback>
                            </FormGroup>
                          </Col> */}
                            <Col sm={3}>
                              <FormGroup className="mb-4">
                                <Label>Email ID</Label>
                                <UFInput
                                  control={control}
                                  placeholder="Enter the Email ID"
                                  name={"email_id"}
                                  invalid={!!errors.email_id}
                                />
                                <FormFeedback invalid>
                                  {errors.email_id?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            <Col sm={3}>
                              <FormGroup className="mb-4">
                                <Label>Address</Label>
                                <UFEditor
                                  control={control}
                                  placeholder="Enter the Address"
                                  rows="3"
                                  name={"address"}
                                  invalid={!!errors.address}
                                />
                                <FormFeedback invalid>
                                  {errors.address?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            <Row>
                              <Col sm={3}>
                                <FormGroup className="mb-4">
                                  <Label>Contact Person</Label>
                                  <UFInput
                                    control={control}
                                    placeholder="Enter the Contact Person"
                                    name={"contact_person"}
                                    invalid={!!errors.contact_person}
                                  />
                                  <FormFeedback invalid>
                                    {errors.contact_person?.message}
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                              <Col sm={3}>
                                <FormGroup className="mb-4">
                                  <Label>Contact Number</Label>
                                  <PhoneInputField
                                    control={control}
                                    name={"customer_number"}
                                    invalid={!!errors.customer_number}
                                    countryCode={watch("countryCode")}
                                    setValue={setValue}
                                  />
                                  <FormFeedback invalid>
                                    {errors.customer_number?.message}
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                              <Col sm={3}>
                                <FormGroup className="mb-4">
                                  <Label>Contact Person Designation</Label>
                                  <UFInput
                                    control={control}
                                    placeholder="Enter the Contact Person Designation"
                                    name={"contact_person_designation"}
                                    invalid={
                                      !!errors.contact_person_designation
                                    }
                                  />
                                  <FormFeedback invalid>
                                    {errors.contact_person_designation?.message}
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                              <Col
                                sm={3}
                                className="d-flex flex-column justify-content-end align-items-start"
                              >
                                {!showAdditionalContacts && (
                                  <Button
                                    color={"secondary"}
                                    className="px-2 btn btn-secondary mt-auto mb-4"
                                    onClick={() =>
                                      setShowAdditionalContacts(true)
                                    }
                                  >
                                    + Add another contact
                                  </Button>
                                )}
                              </Col>
                            </Row>
                            {showAdditionalContacts && (
                              <Row>
                                <Col sm={3}>
                                  <FormGroup className="mb-4">
                                    <Label>Contact Person 2</Label>
                                    <UFInput
                                      control={control}
                                      placeholder="Enter the Contact Person 2"
                                      name={"contact_person_two"}
                                      invalid={!!errors.contact_person_two}
                                    />
                                    <FormFeedback invalid>
                                      {errors.contact_person_two?.message}
                                    </FormFeedback>
                                  </FormGroup>
                                </Col>
                                <Col sm={3}>
                                  <FormGroup className="mb-4">
                                    <Label>Contact Number 2</Label>
                                    <PhoneInputField
                                      control={control}
                                      name={"customer_number_two"}
                                      invalid={!!errors.customer_number_two}
                                      countryCode={watch("countryCode")}
                                      setValue={setValue}
                                    />
                                    <FormFeedback invalid>
                                      {errors.customer_number_two?.message}
                                    </FormFeedback>
                                  </FormGroup>
                                </Col>
                                <Col sm={3}>
                                  <FormGroup className="mb-4">
                                    <Label>Contact Person Designation 2</Label>
                                    <UFInput
                                      control={control}
                                      placeholder="Enter the Contact Person Designation 2"
                                      name={"contact_person_designation_two"}
                                      invalid={
                                        !!errors.contact_person_designation_two
                                      }
                                      // widthof={true}
                                    />
                                    <FormFeedback invalid>
                                      {
                                        errors.contact_person_designation_two
                                          ?.message
                                      }
                                    </FormFeedback>
                                  </FormGroup>
                                </Col>
                                <Col
                                  sm={1}
                                  className="d-flex flex-column justify-content-end align-items-start mb-4"
                                >
                                  {showAdditionalContacts && (
                                    <div
                                      type="button"
                                      className=" p-0 mt-0 trash-img mb-2"
                                      onClick={() => {
                                        setShowAdditionalContacts(false)
                                        reset({
                                          ...getValues(),
                                          contact_person_two: "",
                                          customer_number_two: "",
                                          contact_person_designation_two: "",
                                        })
                                      }}
                                    >
                                      <TrashIcon size={20} />
                                    </div>
                                  )}
                                </Col>
                              </Row>
                            )}
                          </Row>
                        ) : watch("account_group_id")?.value == 22 ? (
                          <Row className="mb-0 mt-2">
                            <Col sm={3}>
                              <FormGroup className="mb-3">
                                <Label>Email ID</Label>
                                <UFInput
                                  control={control}
                                  placeholder="Enter the Email ID"
                                  name={"email_id"}
                                  invalid={!!errors.email_id}
                                />
                                <FormFeedback invalid>
                                  {errors.email_id?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            {/* <Col sm={3}>
                            <FormGroup className="mb-3">
                              <Label>
                                Credit Period
                              </Label>
                              <CreditPeriod
                                control={control}
                                placeholder="Select the Credit Period"
                                name={"creditperiod"}
                                invalid={!!errors.creditperiod}
                                target={"body"}
                              />
                              <FormFeedback invalid>
                                {errors.creditperiod?.message}
                              </FormFeedback>
                            </FormGroup>
                          </Col> */}
                            <Col sm={3}>
                              <FormGroup className="mb-3">
                                <Label>Contact Number</Label>
                                <PhoneInputField
                                  control={control}
                                  name={"contact_number"}
                                  invalid={!!errors.contact_number}
                                />
                                <FormFeedback invalid>
                                  {errors.contact_number?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            <Col sm={3}>
                              <FormGroup className="mb-4">
                                <Label>Country</Label>
                                <Country
                                  control={control}
                                  placeholder="Select the Country"
                                  name={"country_id_1"}
                                  invalid={!!errors.country_id_1}
                                  target={"body"}
                                />
                                <FormFeedback invalid>
                                  {errors.country_id_1?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            <Col sm={3}>
                              <FormGroup className="mb-4">
                                <Label>State</Label>
                                <StateList
                                  control={control}
                                  placeholder="Select the State"
                                  name={"country_id"}
                                  selectedCountry={watch("country_id_1")}
                                />
                                <FormFeedback invalid>
                                  {errors.country_id?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            <Col sm={3}>
                              <FormGroup className="mb-4">
                                <Label>Currency</Label>
                                <CurrencyList
                                  control={control}
                                  placeholder="Select the Currency"
                                  name={"currency_id"}
                                  invalid={!!errors.currency_id}
                                  target={"body"}
                                />
                                <FormFeedback invalid>
                                  {errors.currency_id?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            {/* <Col sm={3}>
                            <FormGroup className="mb-4">
                              <Label>VAT No</Label>
                              <UFInput
                                control={control}
                                placeholder="Enter the VAT No"
                                rows="3"
                                name={"vat_no"}
                                invalid={!!errors.vat_no}
                              />
                              <FormFeedback invalid>
                                {errors.vat_no?.message}
                              </FormFeedback>
                            </FormGroup>
                          </Col> */}
                            <Col sm={3}>
                              <FormGroup className="mb-4">
                                <Label>
                                  Trade Licence No
                                  {/* <span className="mandatory">*</span> */}
                                </Label>
                                <UFInput
                                  control={control}
                                  placeholder="Enter the Trade Licence No"
                                  rows="3"
                                  name={"trade_licence_no"}
                                  invalid={!!errors.trade_licence_no}
                                />
                                <FormFeedback invalid>
                                  {errors.trade_licence_no?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            <Col sm={3}>
                              <FormGroup className="mb-4">
                                <Label>Trade Expiry Date</Label>
                                <UFDate
                                  control={control}
                                  name={"trade_document_expiry_date"}
                                  invalid={!!errors.trade_document_expiry_date}
                                />
                                <FormFeedback invalid>
                                  {errors.trade_document_expiry_date?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            <Col sm={3}>
                              <FormGroup className="mb-4">
                                <Label>
                                  PO Box No
                                  {/* <span className="mandatory">*</span> */}
                                </Label>
                                <UFInput
                                  control={control}
                                  placeholder="Enter the PO Box No"
                                  rows="3"
                                  name={"po_box_no"}
                                  invalid={!!errors.po_box_no}
                                />
                                <FormFeedback invalid>
                                  {errors.po_box_no?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            <Col lg={3}>
                              <FormGroup className="mb-4">
                                <Label>Address</Label>
                                <span className="mandatory">*</span>
                                <UFEditor
                                  control={control}
                                  placeholder="Enter the Address"
                                  rows="5"
                                  name={"address"}
                                  invalid={!!errors.address}
                                  className={"pb-0"}
                                />
                                <FormFeedback invalid>
                                  {errors.address?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            <Col lg={3}>
                              <FormGroup className="mb-4">
                                <Label>Trade Licence</Label>

                                <Col className="file-import-div import-light p-4 hgt-145">
                                  <label
                                    htmlFor="trade_document"
                                    className="m-0 pointer w-100"
                                  >
                                    <input
                                      type="file"
                                      id="trade_document"
                                      name="trade_document"
                                      accept=".pdf"
                                      onChange={event => {
                                        onTradeChange(event)
                                      }}
                                    />

                                    <div className="d-flex justify-content-center pb-2 supplier-doc">
                                      {/* <img
                                src={uploadicon}
                                alt="Export-light"
                                className="Export-light "
                              /> */}
                                      <UploadArrowIcon />
                                    </div>
                                    {tradeFile ? (
                                      <div className="d-flex justify-content-center secondary-text">
                                        <span className="file-up-txt">
                                          {/* {tradeFile?.name || "Trade.pdf"} */}
                                          {tradeFile?.name?.length > 50
                                            ? "..." + tradeFile?.name.slice(-20)
                                            : tradeFile?.name || "Trade.pdf"}
                                        </span>
                                      </div>
                                    ) : (
                                      <>
                                        <div className="d-flex justify-content-center secondary-text">
                                          <span className="upload">
                                            Upload&nbsp;
                                          </span>
                                          <span className="file-up-txt">
                                            Trade Document
                                          </span>
                                        </div>
                                      </>
                                    )}
                                  </label>
                                </Col>
                                <FormFeedback invalid>
                                  {errors.trade_document?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            <Col lg={3}>
                              <FormGroup className="mb-4">
                                <Label>VAT Certificate</Label>
                                <Col className="file-import-div import-light p-4 hgt-145">
                                  <label
                                    htmlFor="vat_document"
                                    className="m-0 pointer w-100"
                                  >
                                    <input
                                      type="file"
                                      id="vat_document"
                                      name="vat_document"
                                      accept=".pdf"
                                      onChange={event => {
                                        onVatChange(event)
                                      }}
                                    />

                                    <div className="d-flex justify-content-center pb-2 supplier-doc">
                                      {/* <img
                                src={uploadicon}
                                alt="Export-light"
                                className="Export-light "
                              /> */}
                                      <UploadArrowIcon />
                                    </div>
                                    {vatFile ? (
                                      <div className="d-flex justify-content-center secondary-text">
                                        <span className="file-up-txt">
                                          {vatFile?.name?.length > 50
                                            ? "..." + vatFile?.name.slice(-20)
                                            : vatFile?.name || "Vat.pdf"}
                                          {/* {vatFile?.name || "Vat.pdf"} */}
                                        </span>
                                      </div>
                                    ) : (
                                      <>
                                        <div className="d-flex justify-content-center secondary-text">
                                          <span className="upload">
                                            Upload&nbsp;
                                          </span>
                                          <span className="file-up-txt">
                                            VAT Certificate
                                          </span>
                                        </div>
                                      </>
                                    )}
                                  </label>
                                </Col>
                                <FormFeedback invalid>
                                  {errors.vat_document?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            <Col lg={3}>
                              <FormGroup className="mb-4">
                                <Label>
                                  Vendor Assessment
                                  {/* <span className="mandatory">*</span> */}
                                </Label>
                                <Col className="file-import-div import-light p-4 hgt-145">
                                  <label
                                    htmlFor="vendor_document"
                                    className="m-0 pointer w-100"
                                  >
                                    <input
                                      type="file"
                                      id="vendor_document"
                                      name="vendor_document"
                                      accept=".pdf"
                                      onChange={event => {
                                        onVendorChange(event)
                                      }}
                                    />

                                    <div className="d-flex justify-content-center pb-2 supplier-doc">
                                      {/* <img
                                src={uploadicon}
                                alt="Export-light"
                                className="Export-light "
                              /> */}
                                      <UploadArrowIcon />
                                    </div>
                                    {vendorFile ? (
                                      <div className="d-flex justify-content-center secondary-text">
                                        <span className="file-up-txt">
                                          {/* {vendorFile?.name || "Vendor.pdf"} */}
                                          {vendorFile?.name?.length > 50
                                            ? "..." +
                                              vendorFile?.name.slice(-20)
                                            : vendorFile?.name || "Vendor.pdf"}
                                        </span>
                                      </div>
                                    ) : (
                                      <>
                                        <div className="d-flex justify-content-center secondary-text">
                                          <span className="upload">
                                            Upload&nbsp;
                                          </span>
                                          <span className="file-up-txt">
                                            Vendor Assessment
                                          </span>
                                        </div>
                                      </>
                                    )}
                                  </label>
                                </Col>
                                <FormFeedback invalid>
                                  {errors.vendor_document?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>

                            {/* <Col lg={8}>
                      <Row></Row> */}
                            {/* <Row>
                        <Col sm={6}>
                          <FormGroup className="mb-4">
                            <Label>
                              VAT No<span className="mandatory">*</span>
                            </Label>
                            <UFInput
                              control={control}
                              placeholder="Enter the VAT No"
                              rows="3"
                              name={"vat_no"}
                              invalid={!!errors.vat_no}
                            />
                            <FormFeedback invalid>
                              {errors.vat_no?.message}
                            </FormFeedback>
                          </FormGroup>
                        </Col>
                      </Row> */}
                            {/* </Col> */}

                            <Col sm={12}>
                              <FormGroup>
                                <input
                                  control={control}
                                  type="checkbox"
                                  className="ever-rise-checkbox"
                                  name={"is_subcontractor"}
                                  onChange={e => handleCheck(e)}
                                  disabled={id ? true : false}
                                  checked={id && isChecked}
                                />
                                <Label className="ms-2"> Sub Contract</Label>
                              </FormGroup>
                            </Col>
                          </Row>
                        ) : (
                          <Row>
                            <Col lg="3" xs={12} md={5} sm={12}>
                              <FormGroup className="mb-4">
                                <Label>
                                  Name
                                  {/* <span className="mandatory">*</span> */}
                                </Label>
                                <UFInput
                                  control={control}
                                  placeholder="Enter the Name"
                                  name={`mail_name`}
                                  invalid={!!errors?.mail_name}
                                />
                                <FormFeedback invalid>
                                  {errors?.mail_name?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            <Col lg="3" xs={12} md={5} sm={12}>
                              <FormGroup className="mb-4">
                                <Label>
                                  Address
                                  <span className="mandatory">*</span>
                                </Label>
                                <UFInput
                                  control={control}
                                  placeholder="Enter the Address"
                                  name={`mail_add`}
                                  invalid={!!errors?.mail_add}
                                />
                                <FormFeedback invalid>
                                  {errors?.mail_add?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            <Col lg="3" xs={12} md={5} sm={12}>
                              <FormGroup className="mb-4">
                                <Label>
                                  Emirate
                                  <span className="mandatory">*</span>
                                </Label>
                                <UFInput
                                  control={control}
                                  placeholder="Enter the Emirate"
                                  name={`mail_emirate`}
                                  invalid={!!errors?.mail_emirate}
                                />
                                <FormFeedback invalid>
                                  {errors?.mail_emirate?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            <Col lg="3" xs={12} md={5} sm={12}>
                              <FormGroup className="mb-4">
                                <Label>
                                  Country
                                  <span className="mandatory">*</span>
                                </Label>
                                <Country
                                  control={control}
                                  placeholder="Select the Country"
                                  name={`mail_country`}
                                  invalid={!!errors?.mail_country}
                                />
                                <FormFeedback invalid>
                                  {errors?.mail_country?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                          </Row>
                        )}
                      </AccordionBody>
                    </AccordionItem>
                  )}
                  {/* <Row>
                    <Col
                      lg={"auto"}
                      onClick={() => handleOpeningBalanceCheck(openingBalance)}
                      className="mt-auto"
                    >
                      <FormGroup className="mt-2">
                        <input
                          type="checkbox"
                          className="ever-rise-checkbox"
                          name={"is_opening_balance"}
                          checked={openingBalance}
                        />
                        <Label className="ms-2">Opening Balance</Label>
                      </FormGroup>
                    </Col>
                  </Row> */}
                  {/* {watch("is_opening_balance") && ( */}
                  {watch("account_group_id")?.value !== 17 && (
                    // <AccordionItem>
                    //   <AccordionHeader targetId="9">
                    //     <span className="edittheamtitle">Opening Balance</span>
                    //   </AccordionHeader>
                    //   <AccordionBody accordionId="9">
                    <Row>
                      <Col lg={3}>
                        <FormGroup>
                          <Label>
                            Opening Balance
                            {/* <span className="mandatory">*</span> */}
                          </Label>
                          <UFInputNumber
                            control={control}
                            placeholder="Enter the Opening Balance"
                            name={"opening_balance"}
                            invalid={!!errors.opening_balance}
                            isDecimal={true}
                          />
                          <FormFeedback invalid>
                            {errors.opening_balance?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col lg={3}>
                        <FormGroup>
                          <Label>
                            Balance Type
                            {/* <span className="mandatory">*</span> */}
                          </Label>
                          <BalanceTypeDrop
                            control={control}
                            placeholder="Select"
                            name={"balance_type"}
                            invalid={!!errors.balance_type}
                            // isDecimal={true}
                          />
                          <FormFeedback invalid>
                            {errors.balance_type?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                    </Row>
                    //   </AccordionBody>
                    // </AccordionItem>
                  )}
                  {/* )} */}
                </Accordion>
              </Col>
            </Row>
            </>
            )}
          </Card>
        </Container>
        <Modal
          isOpen={isModal}
          toggle={toggleSelect}
          size="xl"
          unmountOnClose={false}
          className="custom-modal-ht"
          backdrop={"static"}
        >
          {/* <div> */}
          <div onKeyDown={onKeyDown}>
            <ModalHeader className="custom-modal-header">
              <div className="d-flex justify-content-between">
                <h5 className="ms-2">Bill allocation Details </h5>
                <img
                  src={closeIcon}
                  alt=""
                  onClick={toggleSelectModal}
                  width="10"
                  role="button"
                />
              </div>
            </ModalHeader>
            <ModalBody>
              <Row className="mb-4">
                <Col lg={12} className="mb-4">
                  <table className="estimation-table mb-4">
                    <thead>
                      <tr>
                        <th>Dr/Cr</th>
                        <th>Reference</th>
                        <th>Date</th>
                        <th>Due Date</th>
                        <th>Amount</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {contraFieldsPartial?.map((item, index) => (
                        <>
                          <tr key={`purchase${item.id || index}`}>
                            <td>
                              <FormGroup>
                                <DebitCreditDrop
                                  control={control}
                                  placeholder="Select"
                                  name={`voucher_contra_partial_pay.${index}.type`}
                                  ref={el => (drCrRefs.current[index] = el)}
                                />
                                <FormFeedback invalid>
                                  {
                                    errors.voucher_contra_partial_pay?.[index]
                                      ?.type?.message
                                  }
                                </FormFeedback>
                              </FormGroup>
                            </td>
                            <td>
                              <FormGroup>
                                <UFInput
                                  control={control}
                                  placeholder="Code"
                                  name={`voucher_contra_partial_pay.${index}.code`}
                                  className="ps-1"
                                />
                                <FormFeedback invalid>
                                  {
                                    errors.voucher_contra_partial_pay?.[index]
                                      ?.code?.message
                                  }
                                </FormFeedback>
                              </FormGroup>
                            </td>
                            <td>
                              <FormGroup>
                                <UFDate
                                  control={control}
                                  placeholder="Select Date"
                                  name={`voucher_contra_partial_pay.${index}.date`}
                                  className="ps-1"
                                />
                                <FormFeedback invalid>
                                  {
                                    errors.voucher_contra_partial_pay?.[index]
                                      ?.date?.message
                                  }
                                </FormFeedback>
                              </FormGroup>
                            </td>
                            <td>
                              <FormGroup>
                                <UFDate
                                  control={control}
                                  placeholder="Select Date"
                                  name={`voucher_contra_partial_pay.${index}.due_date`}
                                  className="ps-1"
                                />
                                <FormFeedback invalid>
                                  {
                                    errors.voucher_contra_partial_pay?.[index]
                                      ?.due_date?.message
                                  }
                                </FormFeedback>
                              </FormGroup>
                            </td>
                            <td>
                              <FormGroup>
                                <UFInputNumber
                                  control={control}
                                  placeholder="Amount"
                                  name={`voucher_contra_partial_pay.${index}.amount`}
                                  className="ps-1"
                                  isDecimal={true}
                                  decimalLength={desimalrange || 2}
                                />
                                <FormFeedback invalid>
                                  {
                                    errors.voucher_contra_partial_pay?.[index]
                                      ?.amount?.message
                                  }
                                </FormFeedback>
                              </FormGroup>
                            </td>
                            <td>
                              <div className="pb-1 px-2 d-flex justify-content-center">
                                <div
                                  className="trash-img pointer"
                                  onClick={() => {
                                    contraPartialListRemove(index)
                                    handlePartialRemove(item?.voucher_entry_id)
                                  }}
                                >
                                  <TrashIcon />
                                </div>
                              </div>
                            </td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>
                  <Row>
                    <Col lg="6"></Col>
                    <Col lg="3" className="py-2">
                      <div className="text-end">Total</div>
                    </Col>
                    <Col lg="3" className="py-2">
                      {Number(watch("opening_balance")).toFixed(
                        desimalrange || 2
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6"></Col>
                    <Col lg="3" className="py-2">
                      <div className="text-end">Debit</div>
                    </Col>
                    <Col lg="3" className="py-2">
                      {Number(
                        calculateCreditDebitDifference(
                          watch("voucher_contra_partial_pay") || []
                        )?.totalDebit
                      ).toFixed(desimalrange || 2)}
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6"></Col>
                    <Col lg="3" className="py-2">
                      <div className="text-end">Credit</div>
                    </Col>
                    <Col lg="3" className="py-2">
                      {Number(
                        calculateCreditDebitDifference(
                          watch("voucher_contra_partial_pay") || []
                        )?.totalCredit
                      ).toFixed(desimalrange || 2)}
                    </Col>
                  </Row>
                  {/* {[13, 15, 6, 1, 3, 8].includes(watch("voucher_id")?.value) && ( */}
                  {/* <div className="text-end mt-2 note-txt">
                    Press TAB to handle Values
                  </div> */}
                  {/* )} */}
                </Col>
                {/* <Col lg="12">
                {viewVouchersLi ? (
                  <VoucherEntrySearch
                    fromDashboard={true}
                    editPartial={editPartial} // Added by Adithyan
                    editId={editId} // Added by Adithyan
                    handilUpdate={handilUpdate} // Added by Adithyan
                    onSelect={handlePOSelect}
                    voucherType={viewData?.voucher_type}
                    ledgerId={viewData?.ledger_id}
                    partialPayment={true}
                    voucherLocation={watch("voucher_id")?.value}
                  />
                ) : (
                  <></>
                )}
              </Col> */}
              </Row>
            </ModalBody>
            <ModalFooter>
              <LoadingButton
                form={`ledger-form`}
                color={"primary"}
                loading={isLoading}
                disabled={isLoading}
                type="submit"
              >
                Save
              </LoadingButton>
            </ModalFooter>
          </div>
        </Modal>
      </Form>
    </FormProvider>
  )

  // Render either in offcanvas or normal mode based on props
  if (isOffcanvas) {
    return (
      <Offcanvas
        isOpen={isOpen}
        toggle={toggleOffcanvas}
        direction="end"
        size="lg"
        className="w-width"
      >
        <OffcanvasHeader
          toggle={toggleOffcanvas}
          className="d-flex justify-content-between align-items-end"
        >
          <span>{offcanvasHeader}</span>
          <div className="d-flex justify-content-end align-items-end">
            <Button color="light" onClick={toggleOffcanvas} className="me-2">
              Cancel
            </Button>
            <LoadingButton
              form={formId}
              color={"primary"}
              loading={isLoading}
              disabled={isLoading}
              type="submit"
            >
              {resolvedLedgerId ? "Update" : "Save"}
            </LoadingButton>
          </div>
        </OffcanvasHeader>
        <OffcanvasBody>{formContent}</OffcanvasBody>
      </Offcanvas>
    )
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Container fluid className="ps-lg-0">
          {formContent}
        </Container>
      </div>
    </div>
  )
}

export default LedgerForm
